import React, { useState, useEffect, useRef } from "react";
import { loadModules } from "esri-loader";
import axios from "axios";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaExclamation } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import "./InteractiveMap.css";
import { useLocation } from "react-router-dom";
import { FcInfo } from "react-icons/fc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCog, faTimes } from "@fortawesome/free-solid-svg-icons";
import { jwtDecode } from "jwt-decode";
import "@esri/calcite-components";
import { useNavigate } from "react-router-dom";
import { forEach } from "lodash";
import { RiArrowGoBackFill } from "react-icons/ri";
import { useTranslation } from "react-i18next";

let arcgisConfig = null; // გლობალურად
const baseURL = process.env.REACT_APP_API_BASE_URL;
const cleanBaseURL = baseURL?.replace("/api", "");
//const baseURL = process.env.REACT_APP_API_BASE_URL;

const options = { version: "4.27", css: true };
const InteractiveMap = () => {
  document.addEventListener("DOMContentLoaded", function () {
    var elements = document.querySelectorAll(".esri-layer-list__item-label");
    elements.forEach(function (element) {
      element.setAttribute("title", "გამოჩნდეს");
      element.style.color = "white";
    });
  });
  const [fenebisbar, setFenebisbar] = useState(false);
  const [hamToggle, setHamToggle] = useState(true);
  const [showMapPopup, setShowMapPopup] = useState(false);
  const [isLightLayer, setIsLightLayer] = useState(false);
  const popupRef = useRef(null);
  const { t, i18n } = useTranslation();

  const [language, setLanguage] = useState('');
  const [mapKey, setMapKey] = useState(0); // გამოიყენება რერენდერისთვის
  const languageRef = useRef(language); // useRef to store the language without causing re-render



  useEffect(() => {
    const onLanguageChange = (lng) => {
      // Your ArcGIS JS code goes here
      setLanguage(lng)
      languageRef.current = lng; // Update the ref with the new language
      var test = language;

      if (arcgisConfig) {
        arcgisConfig.locale = lng;
        setMapKey((prev) => prev + 1); // აიძულებს Map-ის ხელახალ ჩატვირთვას
      }

      // const token = localStorage.getItem("jwtToken");
      // if (token) {
      //   try {
      //     const decoded = jwtDecode(token);
      //     setRole(decoded.role);
      //     // initializeMap(decoded.role);
      //     initializeMap(decoded.role, lng); // 👈 ენით გადავცეთ
      //   } catch (error) { }
      // }
      // //თუ როლი ცარიელია
      // else {
      //   initializeMap(null);
      // }
      //updateArcGISLanguage(lng);
    };

    // Listen for language change events
    i18n.on("languageChanged", onLanguageChange);

    // Clean up the event listener
    return () => {
      i18n.off("languageChanged", onLanguageChange);
    };
  }, [i18n]);
  // This useEffect will run every time the language changes
  useEffect(() => {
    if (language) {
      // Here, you can call your function to update ArcGIS
      // updateArcGISLanguage(language);
    }
  }, [language]); // Runs when 'language' state changes
  const darkLayersArray = [
    "Imagery",
    "Imagery Hybrid",
    "Streets (Night)",
    "Dark Gray Canvas",
    "Navigation (Dark)",
    "Nova Map",
    "Firefly Imagery Hybrid",
    "Blueprint",
    "Enhanced Contrast Dark Map",
    "Human Geography Dark Map",
    "სატელიტური",
    "სატელიტურ ჰიბრიდული",
    "ქუჩების (ღამე)",
    "მუქი ნაცრისფერი ტილო",
    "ნავიგაციური ბნელი",
    "ნოვას რუკა",
    "მანათობელი სატელიტური რუკა",
    "გეგმური",
    "გაძლიერებულ კონტრასტული მუქი რუკა",
    "საზოგადოებრივ გეოგრაფიული მუქი რუკა",
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        // Click occurred outside of the popup, so close it
        setShowMapPopup(false);
      }
    };

    // Add event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up by removing event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const togglePopup = () => {
    setShowMapPopup(!showMapPopup);
  };

  //Search Settings Checkboxes session storage
  const [tcsaLayerChecked, setTCSALayerChecked] = useState(true);
  const [sakadastroLayerChecked, setsakadastroLayerChecked] = useState(true);
  useEffect(() => {
    // Load saved state from session storage on component mount
    const savedTCSALayerChecked = sessionStorage.getItem("tcsaLayerChecked");
    const savedsakadastroLayerChecked = sessionStorage.getItem(
      "sakadastroLayerChecked"
    );

    if (savedTCSALayerChecked !== null) {
      setTCSALayerChecked(savedTCSALayerChecked === "true" ? true : false);
    }

    if (savedsakadastroLayerChecked !== null) {
      setsakadastroLayerChecked(
        savedsakadastroLayerChecked === "true" ? true : false
      );
    }
  }, []);
  useEffect(() => {
    // Save state to session storage whenever it changes
    sessionStorage.setItem("tcsaLayerChecked", tcsaLayerChecked);
    sessionStorage.setItem("sakadastroLayerChecked", sakadastroLayerChecked);
  }, [tcsaLayerChecked, sakadastroLayerChecked]);

  //////////poupup
  const location = useLocation();
  const mapRef = useRef();
  const mapViewRef = useRef(null);
  const basemapGalleryRef = useRef(null);
  const basemapTitleRef = useRef(null);
  const legendExpandRef = useRef(null);
  const [sidebarOpen, setsidebarOpen] = useState(null);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null);
  const [showSearchSettingsPopup, setSearchSettingsShowPopup] = useState(false);
  const [popupsEnabled, setpopupsEnabled] = useState(false);

  useEffect(() => {
    document.body.className = `route-${location.pathname.replace('/', '') || 'interactivemap'}`;
  }, [location]);

  useEffect(() => {
    if (showSearchSettingsPopup) {
      const searchSettingsPopupStyle = document.getElementById(
        "searchSettingsPopup"
      );
      if (searchSettingsPopupStyle) {
        searchSettingsPopupStyle.classList.toggle(
          "searchSettingsPopupDiv-dark",
          isLightLayer
        );
      }
    }
  }, [showSearchSettingsPopup]);

  useEffect(() => {
    // Check if pathname includes interactivemap or map
    if (
      location.pathname.includes("interactivemap") ||
      location.pathname.includes("map")
    ) {
      setLoading(true);

      // Set a timeout to hide the loading screen after 5 seconds
      const timeout = setTimeout(() => {
        setLoading(false);
      }, 3500);

      // Cleanup the timeout if the component unmounts
      return () => clearTimeout(timeout);
    }
  }, [location.pathname]);

  const handleToggle = () => {
    setHamToggle((prev) => !prev); // Toggle state based on previous value
  };

  useEffect(() => {
    const arrowClosed = document.querySelectorAll(
      ".esri-layer-list__child-toggle"
    );
    arrowClosed.forEach((element) => {
      element.style.color = "white";
    });

    const checkboxColor = document.querySelectorAll(
      ".esri-layer-list__item-toggle"
    );
    checkboxColor.forEach((element) => {
      element.style.color = "white";
    });
  }, [mapRef]);

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // This goes back one step in the history
    document.body.className = '';
  };
  const toggleSearchSettingsPopup = () => {
    setSearchSettingsShowPopup(!showSearchSettingsPopup);
    const suggestionsDiv = document.getElementById("suggestions");
    suggestionsDiv.style = "visibility:hidden";
  };

  const closeSearchSettingsPopup = () => {
    setSearchSettingsShowPopup(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const token = localStorage.getItem("jwtToken");
      const lng = i18n.language; // 🎯 აი ეს დაამატე
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setRole(decoded.role);
          // initializeMap(decoded.role);
          initializeMap(decoded.role, lng); // 👈 ენით გადავცეთ
        } catch (error) { }
      }
      //თუ როლი ცარიელია
      else {
        initializeMap(null);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (basemapGalleryRef.current) {
      updateBasemapTitles(basemapGalleryRef.current);
    } if (basemapTitleRef.current) {
      basemapTitleRef.current.expandTooltip = t("საბაზისო ფენები");
    }
    if (legendExpandRef.current) {
      legendExpandRef.current.expandTooltip = t("რუკის ლეგენდის ნახვა");
    }

    // ლოკაციის ღილაკი
    const trackButton = document.querySelector(
      ".esri-widget--button[title='Start Tracking My Location'], .esri-widget--button[title='მაჩვენე ჩემი მდებარეობა']"
    );
    if (trackButton) {
      trackButton.title = t("მაჩვენე ჩემი მდებარეობა");
    }
    // zoom In ის ღილაკი
    const zoomInButton = document.querySelector(
      ".esri-widget--button[title='Zoom-In'], .esri-widget--button[title='მიახლოება']"
    );
    if (zoomInButton) {

      zoomInButton.title = `${t("მიახლოება")}`; // Zoom out translation
    }
    // zoom out ის ღილაკი
    const zoomOutButton = document.querySelector(
      ".esri-widget--button[title='Zoom-Out'], .esri-widget--button[title='დაშორება']"
    );
    if (zoomOutButton) {
      zoomOutButton.title = `${t("დაშორება")}`; // Zoom out translation
    }
    //კომპასის ღილაკი
    const compassButton = document.querySelector(".esri-compass__icon");

    if (compassButton) {
      compassButton.setAttribute("title", t("კომპასი")); // ← შენი hover ტექსტი
    }
    const ResetCompassButton = document.querySelector(".esri-widget--button[title='Reset map orientation']");
    if (ResetCompassButton) {
      ResetCompassButton.setAttribute("title", ""); // ← შენი hover ტექსტი
    }

    // zoom out ის ღილაკი
    const printButton = document.querySelector(
      ".esri-widget--button[title='Print'], .esri-widget--button[title='ამოპრინტვა']"
    );
    if (printButton) {
      printButton.title = `${t("ამოპრინტვა")}`; // Zoom out translation
    }

  }, [i18n.language]); // ენის შეცვლაზე და როცა უკვე არის ready
  function updateBasemapTitles(gallery) {
    gallery.source.basemaps.forEach((basemap) => {
      if (basemap.loaded) {
        if (basemap.title === "Topographic" || basemap.title === "ტოპოგრაფიული") {
          basemap.title = t("ტოპოგრაფიული");
        } else if (basemap.title === "Streets" || basemap.title === "ქუჩები") {
          basemap.title = t("ქუჩები");
        } else if (basemap.title === "Imagery" || basemap.title === "სატელიტური") {
          basemap.title = t("სატელიტური");
        } else if (basemap.title === "Imagery Hybrid" || basemap.title === "სატელიტურ ჰიბრიდული") {
          basemap.title = t("სატელიტურ ჰიბრიდული");
        } else if (basemap.title === "Navigation" || basemap.title === "ნავიგაციური") {
          basemap.title = t("ნავიგაციური");
        } else if (basemap.title === "Navigation (Dark)" || basemap.title === "ნავიგაციური ბნელი") {
          basemap.title = t("ნავიგაციური ბნელი");
        } else if (basemap.title === "Newspaper Map" || basemap.title === "გაზეთის რუკა") {
          basemap.title = t("გაზეთის რუკა");
        } else if (basemap.title === "Community Map" || basemap.title === "საზოგადოებრივი") {
          basemap.title = t("საზოგადოებრივი");
        } else if (basemap.title === "Streets (Night)" || basemap.title === "ქუჩების (ღამე)") {
          basemap.title = t("ქუჩების (ღამე)");
        } else if (basemap.title === "Terrain with Labels" || basemap.title === "ფიზიკურ ტვისობრივი ეტიკეტები") {
          basemap.title = t("ფიზიკურ ტვისობრივი ეტიკეტები");
        } else if (basemap.title === "Light Gray Canvas" || basemap.title === "ღია ნაცრისფერი ტილო") {
          basemap.title = t("ღია ნაცრისფერი ტილო");
        } else if (basemap.title === "Dark Gray Canvas" || basemap.title === "მუქი ნაცრისფერი ტილო") {
          basemap.title = t("მუქი ნაცრისფერი ტილო");
        } else if (basemap.title === "Outdoor" || basemap.title === "გარე სივრცის") {
          basemap.title = t("გარე სივრცის");
        } else if (basemap.title === "Oceans" || basemap.title === "ოკეანეების") {
          basemap.title = t("ოკეანეების");
        } else if (basemap.title === "National Geographic Style Map" || basemap.title === "ნაციონალური გეოგრაფიული რუკა") {
          basemap.title = t("ნაციონალური გეოგრაფიული რუკა");
        } else if (basemap.title === "OpenStreetMap" || basemap.title === "ღია ქუჩების რუკა") {
          basemap.title = t("ღია ქუჩების რუკა");
        } else if (basemap.title === "Charted Territory Map" || basemap.title === "კარტირებული ტერიტორიების რუკა") {
          basemap.title = t("კარტირებული ტერიტორიების რუკა");
        } else if (basemap.title === "Human Geography Map" || basemap.title === "საზოგადოებრივ გეოგრაფიული რუკა") {
          basemap.title = t("საზოგადოებრივ გეოგრაფიული რუკა");
        } else if (basemap.title === "Human Geography Dark Map" || basemap.title === "საზოგადოებრივ გეოგრაფიული მუქი რუკა") {
          basemap.title = t("საზოგადოებრივ გეოგრაფიული მუქი რუკა");
        } else if (basemap.title === "Modern Antique Map" || basemap.title === "თანამედროვე ანტიკური რუკა") {
          basemap.title = t("თანამედროვე ანტიკური რუკა");
        } else if (basemap.title === "Mid-Century Map" || basemap.title === "შუასაუკუნეების რუკა") {
          basemap.title = t("შუასაუკუნეების რუკა");
        } else if (basemap.title === "Nova Map" || basemap.title === "ნოვას რუკა") {
          basemap.title = t("ნოვას რუკა");
        } else if (basemap.title === "Colored Pencil Map" || basemap.title === "ფერადი ფანქრის რუკა") {
          basemap.title = t("ფერადი ფანქრის რუკა");
        } else if (basemap.title === "Firefly Imagery Hybrid" || basemap.title === "მანათობელი სატელიტური რუკა") {
          basemap.title = t("მანათობელი სატელიტური რუკა");
        } else if (basemap.title === "Blueprint" || basemap.title === "გეგმური") {
          basemap.title = t("გეგმური");
        } else if (basemap.title === "Enhanced Contrast Map" || basemap.title === "გაძლიერებული კონტრასტული რუკა") {
          basemap.title = t("გაძლიერებული კონტრასტული რუკა");
        } else if (basemap.title === "Enhanced Contrast Dark Map" || basemap.title === "გაძლიერებულ კონტრასტული მუქი რუკა") {
          basemap.title = t("გაძლიერებულ კონტრასტული მუქი რუკა");
        } else if (basemap.title === "Topographic (Vector)" || basemap.title === "ტოპოგრაფიული რუკა (ვექტორული)") {
          basemap.title = t("ტოპოგრაფიული რუკა (ვექტორული)");
        } else if (basemap.title === "Environment Map" || basemap.title === "ეკოლოგიური რუკა") {
          basemap.title = t("ეკოლოგიური რუკა");
        } else if (basemap.title === "Navigation (Places)" || basemap.title === "ნავიგაცია (ადგილები)") {
          basemap.title = t("ნავიგაცია (ადგილები)");
        } else if (basemap.title === "Navigation (Dark - Places)" || basemap.title === "ნავიგაცია (მუქი თემა – ადგილები)") {
          basemap.title = t("ნავიგაცია (მუქი თემა – ადგილები)");
        }



        document.querySelectorAll(".esri-basemap-gallery__item").forEach(item => {
          const labelSpan = item.querySelector(".esri-basemap-gallery__item-title span");
          if (!labelSpan) return;

          const titleText = labelSpan.textContent;

          if (titleText === "Imagery" || titleText === "სატელიტური") {
            item.title = t("ეს რუკა მოიცავს დეტალურ საცნობარო შრეს მსოფლიოსთვის, რომელიც დაფენილია სატელიტურ გამოსახულებაზე.");
          }

          if (titleText === "Imagery Hybrid" || titleText === "სატელიტურ ჰიბრიდული") {
            item.title = t("ეს რუკა მსოფლიოს სატელიტურ გამოსახულებას და მრავალი ტერიტორიის მაღალი გარჩევადობის აეროგამოსახულებას მოიცავს.");
          }

          if (titleText === "Streets" || titleText === "ქუჩები") {
            item.title = t("ეს რუკა მსოფლიოსთვის მაგისტრალებისა და ქუჩების დეტალურ მონაცემებს ასახავს.");
          }

          if (titleText === "Topographic" || titleText === "ტოპოგრაფიული") {
            item.title = t("ეს ტოპოგრაფიული რუკა განკუთვნილია, როგორც საბაზო რუკა და საცნობარო რუკა. რუკა შედგენილია Esri-ის და ArcGIS მომხმარებელთა საზოგადოების მიერ, საუკეთესო ხელმისაწვდომი წყაროებიდან.");
          }

          if (titleText === "Navigation" || titleText === "ნავიგაციური") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას მორგებული სანავიგაციო რუკის სტილით.");
          }

          if (titleText === "Navigation (Dark)" || titleText === "ნავიგაციური ბნელი") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას მორგებული ღამის ქუჩის რუკის სტილით.");
          }

          if (titleText === "Newspaper Map" || titleText === "გაზეთის რუკა") {
            item.title = t("ეს რუკა ასახავს დაჩრდილული რელიეფის გამოსახულებას, ბათიმეტრიას და სანაპირო წყლის მახასიათებლებს, რომლებიც უზრუნველყოფენ ნეიტრალურ ფონს პოლიტიკური საზღვრებითა და ადგილების სახელებით საცნობარო მიზნებისთვის.");
          }

          if (titleText === "Community Map" || titleText === "საზოგადოებრივი") {
            item.title = t("ეს რუკა შექმნილია იმისთვის, რომ თქვენი თემატური შინაარსისკენ მიაპყროს ყურადღება ნეიტრალური ფონის უზრუნველყოფით, მინიმალური ფერებით, ეტიკეტებითა და მახასიათებლებით.");
          }

          if (titleText === "Streets (Night)" || titleText === "ქუჩების (ღამე)") {
            item.title = t("ეს ვებ რუკა გთავაზობთ დეტალურ საბაზო რუკას ბუნებრივ სამყაროზე აქცენტით. ის მოიცავს მდიდარ კარტოგრაფიულ სტილს ვექტორული კონტურებითა და ვექტორული ბორცვების დაჩრდილვით (hillshade). ეს არის მრავალწყაროიანი სტილი.");
          }

          if (titleText === "Terrain with Labels" || titleText === "ფიზიკურ ტვისობრივი ეტიკეტები") {
            item.title = t("ეს რუკა შექმნილია, როგორც საბაზო რუკა საზღვაო GIS პროფესიონალებისთვის და როგორც საცნობარო რუკა ყველასთვის, ვინც ოკეანის მონაცემებით არის დაინტერესებული.");
          }

          if (titleText === "Light Gray Canvas" || titleText === "ღია ნაცრისფერი ტილო") {
            item.title = t("ეს ვექტორული ვებ რუკა გთავაზობთ მსოფლიოს დეტალურ ხედს ლამაზი პოლიტიკური საზღვრებით, წარწერებითა და ფონით, რომელიც ხაზს უსვამს მიწის ფიზიკური მახასიათებლების განსხვავებებს.");
          }

          if (titleText === "Dark Gray Canvas" || titleText === "მუქი ნაცრისფერი ტილო") {
            item.title = t("OpenStreetMap (OSM) არის ერთობლივი პროექტი, რომელიც მიზნად ისახავს მსოფლიოს თავისუფალი, რედაქტირებადი რუკის შექმნას. ეს ვექტორული საბაზო რუკა დაფუძნებულია OSM მონაცემთა Daylight რუკის დისტრიბუციაზე და მასპინძლობს Esri. ვექტორული შრე წარმოდგენილია OSM კარტოგრაფიით.");
          }

          if (titleText === "Outdoor" || titleText === "გარე სივრცის") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ ფილების (tile) საბაზო რუკას გეოპოლიტიკური სტილით, რომელიც ბეჭდური ატლასის ფურცელს ან სასკოლო საკლასო ოთახის კედლის რუკას მოგაგონებთ.");
          }

          if (titleText === "Oceans" || titleText === "ოკეანეების") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ ფილების (tile) საბაზო რუკას სტილით, რომელიც ოპტიმიზებულია სპეციალური ინტერესის ზონების (AOIs) საჩვენებლად, რომლებიც შექმნილი და რედაქტირებულია Community Maps-ის კონტრიბუტორების მიერ.");
          }

          if (titleText === "National Geographic Style Map" || titleText === "ნაციონალური გეოგრაფიული რუკა") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას მორგებული მუქი რეჟიმის სანავიგაციო რუკის სტილით.");
          }

          if (titleText === "OpenStreetMap" || titleText === "ღია ქუჩების რუკა") {
            item.title = t("ეს რუკა არის შავ-თეთრი დიზაინი ნახევარტონური შაბლონებით (halftone patterns), წითელი აქცენტებით და სტილიზებული შრიფტებით.");
          }

          if (titleText === "Charted Territory Map" || titleText === "კარტირებული ტერიტორიების რუკა") {
            item.title = t("ეს რუკა შედგება ვექტორული ფილების შრეებისგან, რომლებიც მსოფლიოს დეტალურ საბაზო რუკას ქმნიან, მუქი მონოქრომატული სტილით და შინაარსით, რომელიც მორგებულია ადამიანის გეოგრაფიის ინფორმაციის მხარდასაჭერად.");
          }

          if (titleText === "Human Geography Map" || titleText === "საზოგადოებრივ გეოგრაფიული რუკა") {
            item.title = t("რუკის უნიკალური მორგება. მე-18 და მე-19 საუკუნეების ანტიკური რუკების იერსახის განახლება მულტი-მასშტაბიანი რუკების თანამედროვე სამყაროში.");
          }

          if (titleText === "Human Geography Dark Map" || titleText === "საზოგადოებრივ გეოგრაფიული მუქი რუკა") {
            item.title = t("ეს მორგებული რუკა, 1950-იანი წლების ხელოვნებისა და რეკლამის შთაგონებით, წარმოადგენს უნიკალურ დიზაინის ვარიანტს ArcGIS-ის საბაზო რუკებისთვის.");
          }

          if (titleText === "Modern Antique Map" || titleText === "თანამედროვე ანტიკური რუკა") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ ფილების (tile) საბაზო რუკას მუქი ფონით და მოციმციმე ლურჯი სიმბოლოებით, რაც ArcGIS.com-ის მისასალმებელი ეკრანით (splash screen) არის შთაგონებული.");
          }

          if (titleText === "Mid-Century Map" || titleText === "შუასაუკუნეების რუკა") {
            item.title = t("ეს ვებ რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას ხელნაკეთი იერით, თითქოს ფერადი ფანქრებით იყოს შექმნილი.");
          }

          if (titleText === "Nova Map" || titleText === "ნოვას რუკა") {
            item.title = t("ეს რუკა დაფუძნებულია OSM მონაცემთა Daylight რუკის დისტრიბუციაზე და მასპინძლობს Esri. რუკა წარმოდგენილია კრეატიული კარტოგრაფიული სტილით, რომელიც ასახავს ტექნიკური ნახაზის (blueprint) იერსახეს.");
          }

          if (titleText === "Colored Pencil Map" || titleText === "ფერადი ფანქრის რუკა") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ საბაზო რუკას კლასიკური Esri ტოპოგრაფიული რუკის სტილით, ვექტორული კონტურებითა და ბორცვების დაჩრდილვის (hillshade) შრეებით. ეს არის მრავალწყაროიანი სტილი.");
          }

          if (titleText === "Firefly Imagery Hybrid" || titleText === "მანათობელი სატელიტური რუკა") {
            item.title = t("მსოფლიოს დეტალური რუკა, რომელიც გამოირჩევა ნეიტრალური სტილით და შინაარსით, რომელიც მორგებულია გარემოს, ლანდშაფტის, ბუნებრივი რესურსების, ჰიდროლოგიური და ფიზიკური გეოგრაფიის შრეების მხარდასაჭერად.");
          }

          if (titleText === "Blueprint" || titleText === "გეგმური") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ საბაზო რუკას გაძლიერებული კონტრასტით, რომელიც მიზნად ისახავს WCAG-ისა და აშშ-ის მთავრობის 508-ე სექციის სტანდარტებთან შესაბამისობას. რუკის დეტალები აგებულია უფრო მაღალი კონტრასტით და ფერთა მხედველობის დეფიციტისთვის უსაფრთხო ფერებით.");
          }

          if (titleText === "Enhanced Contrast Map" || titleText === "გაძლიერებული კონტრასტული რუკა") {
            item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ საბაზო რუკას მუქი ფერებითა და გაძლიერებული კონტრასტით, რომელიც მიზნად ისახავს WCAG-ისა და აშშ-ის მთავრობის 508-ე სექციის სტანდარტებთან შესაბამისობას. რუკის დეტალები აგებულია უფრო მაღალი კონტრასტით და ფერთა მხედველობის დეფიციტისთვის უსაფრთხო ფერებით.");
          }

          if (titleText === "Enhanced Contrast Dark Map" || titleText === "გაძლიერებულ კონტრასტული მუქი რუკა") {
            item.title = t("ეს რუკა წარმოადგენს სანავიგაციო საბაზო რუკის მორგებულ ვერსიას დეტალური ადგილებით, ანუ ინტერესის წერტილებით.");
          }

          if (titleText === "Topographic (Vector)" || titleText === "ტოპოგრაფიული რუკა (ვექტორული)") {
            item.title = t("ეს რუკა წარმოადგენს სანავიგაციო მუქი საბაზო რუკის მორგებულ ვერსიას დეტალური ადგილებით, ანუ ინტერესის წერტილებით.");
          }
        });
      }

    });
  }

  function handleViewSidebar() {
    //this.setState({ sidebarOpen: !this.state.sidebarOpen })
    setsidebarOpen(sidebarOpen);
  }
  const initializeMap = (role, lng) => {
    //function initializeMap(role, lng) {
    var layerList;
    loadModules(
      [
        "esri/config",
        "esri/core/urlUtils",
        "esri/views/MapView",
        "esri/layers/GroupLayer",
        "esri/widgets/Bookmarks",
        "esri/Map",
        "esri/request",
        "esri/geometry/Extent",
        "esri/layers/MapImageLayer",
        "esri/layers/FeatureLayer",
        "esri/layers/WMSLayer",
        "esri/core/Handles",
        "esri/widgets/Feature",
        "esri/layers/GraphicsLayer",
        "esri/Graphic",
        "esri/widgets/Compass",
        "esri/widgets/Popup",
        "esri/widgets/Measurement",
        "esri/widgets/Legend",
        "esri/widgets/Expand",
        "esri/widgets/BasemapGallery",
        "esri/widgets/LayerList",
        "esri/symbols/SimpleMarkerSymbol",
        "esri/widgets/Print",
        "esri/widgets/Home",
        "esri/rest/identify",
        "esri/rest/support/IdentifyParameters",
        "esri/widgets/Search",
        "esri/core/reactiveUtils",
        "esri/rest/query",
        "esri/PopupTemplate",
        "esri/geometry/geometryEngine",
        "esri/widgets/Track",
        "esri/smartMapping/labels/clusters",
        "esri/smartMapping/popup/clusters"
      ],
      options
    ).then(
      ([
        esriConfig,
        urlUtils,
        MapView,
        GroupLayer,
        Bookmarks,
        Map,
        esriRequest,
        Extent,
        MapImageLayer,
        FeatureLayer,
        WMSLayer,
        Handles,
        Feature,
        GraphicsLayer,
        Graphic,
        Compass,
        Popup,
        Measurement,
        Legend,
        Expand,
        BasemapGallery,
        LayerList,
        SimpleMarkerSymbol,
        Print,
        Home,
        identify,
        IdentifyParameters,
        Search,
        reactiveUtils,
        query,
        PopupTemplate,
        geometryEngine,
        Track,
        clusterLabelCreator,
        clusterPopupCreator,
        on
      ]) => {
        esriConfig.locale = languageRef.current; // გამოიყენე უკვე არჩეული ენა
        var testttt = baseURL;
        esriConfig.request.corsDetection = false;
        //esriConfig.request.proxyUrl =          "https://tcsa.tacsa.gov.ge/DotNet/proxy.ashx";
        esriConfig.request.proxyUrl = `${cleanBaseURL}/DotNet/proxy.ashx`
        esriConfig.request.alwaysUseProxy = false;
        urlUtils.addProxyRule({
          urlPrefix: "https://gis.economy.ge/server/rest/services",
          //proxyUrl: "https://tcsa.tacsa.gov.ge/DotNet/proxy.ashx",
          proxyUrl: `${cleanBaseURL}/DotNet/proxy.ashx`
        });
        urlUtils.addProxyRule({
          urlPrefix: "https://gis.economy.ge/server/rest/directories",
          // proxyUrl: "https://tcsa.tacsa.gov.ge/DotNet/proxy.ashx",
          proxyUrl: `${cleanBaseURL}/DotNet/proxy.ashx`
        });
        var ManageMapLayersArray = [];
        let params;
        // Create new instance of the Measurement widget
        const measurement = new Measurement();

        // Create the parent group layer
        const parentGroupLayer = new GroupLayer({
          title: "დამფარავი ფენები",
          visibilityMode: "independent",
        });

        // Function to find the parent layer of the given sublayer
        function findParentLayer(groupLayer, targetSublayer) {
          let parentLayer = null;

          groupLayer.layers.forEach((layer) => {
            if (layer.layers) {
              layer.layers.forEach((sublayer) => {
                if (sublayer.layerId === targetSublayer.layerId) {
                  parentLayer = layer;
                }
              });
            }
          });

          return parentLayer;
        }
        // const resetingHeaderNavigationComponents =
        //   document.querySelectorAll(".header-link");

        // if (location.pathname.includes("interactivemap")) {
        //   resetingHeaderNavigationComponents.forEach((element) => {
        //     element.classList.add("header-link-white");
        //   });
        // } else {
        //   resetingHeaderNavigationComponents.forEach((element) => {
        //     element.classList.remove("header-link-white");
        //   });
        // }

        // Create layer showing sample data of the United States.
        // URL to the map service where the identify will be performed
        const identifyURLTCSALayer =
          "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphics/MapServer";
        const TCSALayer = new MapImageLayer({
          url: identifyURLTCSALayer,
          title: "ფენები",
        });
        TCSALayer.listMode = "hide"; //aleks
        const identifyURLTCSAOldLayer =
          "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer";
        const TCSAOldLayer = new MapImageLayer({
          url: identifyURLTCSAOldLayer,
          title: "TCSA ძველი"
        });
        const featureLayerAfetqebisNebarTvaOld = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/1",
          title: 'აფეთქების ნებართვა ძველი'
        });
        const featureLayerIstadiaOld = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/2",
          title: 'I სტადიის ობიექტები ძველი'
        });
        const featureLayerIIstadiaOld = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/3",
          title: 'II და III სტადიის ობიექტები ძველი'
        });


        // Create the parent group layer
        const TCSAOLDGroupLayer = new GroupLayer({
          title: "ძველი ობიექტები",
          visible: false,
          visibilityMode: "independent",
        });
        // Create the parent group layer
        const TCSAOLDUwyebriviGroupLayer = new GroupLayer({
          title: "უწყებრივი რეესტრი ძველი",
          visible: false,
          visibilityMode: "independent",
        });
        const featureLayerkarieri = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/9",
          title: 'კარიერი ძველი'
        });
        const featureLayerwnevazemomushavewurwerli = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/16",
          title: 'წნევაზე მომუშავე ჭურჭელი ძველი'
        });
        const featureLayersaqvabedanadgari = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/15",
          title: 'საქვაბე დანადგარი ძველი'
        });
        const featureLayeratraqcioni = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/7",
          title: 'ატრაქციონი ძველი'
        });
        const featureLayersabagirogza = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/14",
          title: 'საბაგირო გზა ძველი'
        });
        const featureLayereskalatori = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/8",
          title: 'ესკალატორი ძველი'
        });
        const featureLayerlifti = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/10",
          title: 'ლიფტი ძველი'
        });
        const featureLayeramwemowyobiloba = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/6",
          title: 'ამწე მოწყობილობა ძველი'
        });
        const featureLayermagistralurinavtobsadeni = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/11",
          title: 'მაგისტრალური ნავთობსადენი ძველი'
        });
        const featureLayernavtobbaza = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/13",
          title: 'ნავთობბაზა ძველი'
        });
        const featureLayermagaro = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/12",
          title: 'მაღარო ძველი'
        });
        const featureLayeramiakzemomushavesamacivredanadgari = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/5",
          title: 'სამეწარმეო დანიშნულებით გამოყენებადი, ამიაკზე მომუშავე სამაცივრო დანადგარი ძველი'
        });
        const featureLayerUwyebriviLineOld = new FeatureLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphicsOld/MapServer/17",
          title: 'უწყებრივი რეესტრი (ხაზოვანი ობიექტები) ძველი'
        });
        TCSAOLDUwyebriviGroupLayer.addMany([
          featureLayermagaro,
          featureLayeramiakzemomushavesamacivredanadgari,
          featureLayernavtobbaza,
          featureLayermagistralurinavtobsadeni,
          featureLayeramwemowyobiloba,
          featureLayerlifti,
          featureLayereskalatori,
          featureLayersabagirogza,
          featureLayeratraqcioni,
          featureLayersaqvabedanadgari,
          featureLayerwnevazemomushavewurwerli,
          featureLayerkarieri]);
        // then we load a web map from an id
        const map = new Map({
          basemap: "hybrid",
          layers: [TCSALayer],
        });
        TCSAOLDGroupLayer.addMany([
          featureLayerUwyebriviLineOld,
          TCSAOLDUwyebriviGroupLayer,
          featureLayerIIstadiaOld,
          featureLayerIstadiaOld,
          featureLayerAfetqebisNebarTvaOld
        ]);
        if (role && role !== "USER") {
          //map.add(TCSAOldLayer);
          map.add(TCSAOLDGroupLayer);
        }
        map.add(parentGroupLayer);
        const view = new MapView({
          container: mapRef.current,
          map: map,
          center: [43.367997, 42.095516],
          //popupEnabled: false,
          popup: new Popup(),
          zoom: 8,
        });
        // 🧠 აქ ინახავ View-ს Ref-ში
        mapViewRef.current = view;
        const TCSAManageMapLayers = new MapImageLayer({
          url: "https://gis.economy.ge/server/rest/services/TCSA/ManageMapLayers/MapServer",
          listMode: "hide", // Hide this layer from the LayerList
          visible: false, // Optionally make this layer invisible on the map
        });

        const navigatorComponents = document.querySelectorAll(".header-link");
        navigatorComponents.forEach((navigatorComponents) => {
          navigatorComponents.classList.remove("header-link-dark");
        });
        const loginButtonText = document.querySelector(".header-button-text");
        const loginButtonIcon = document.querySelector(".header-icon");
        const loginButton = document.querySelector(".login-button");
        if (loginButton != null) {
          loginButton.classList.remove("login-button-border-dark");
          loginButtonText.classList.remove("login-button-dark");
          loginButtonIcon.classList.remove("header-icon-dark");
        }
        const searchTextColor = document.querySelector(".searchText");
        searchTextColor.classList.remove("searchText-dark");

        map.add(TCSAManageMapLayers);

        map.watch("basemap", function (newValue, oldValue) {
          const listTitle = document.querySelectorAll(
            ".esri-layer-list__item-title"
          );
          const listCheckboxes = document.querySelectorAll(
            ".esri-layer-list__item-toggle"
          );
          const listChildToggle = document.querySelectorAll(
            ".esri-layer-list__child-toggle"
          );
          const infoDots = document.querySelectorAll(
            ".esri-icon-handle-horizontal"
          );
          const suggestionParents =
            document.querySelectorAll(".accordion-button");

          const layersName = document.querySelectorAll(
            ".esri-basemap-gallery__item-title"
          );
          const optionsHeader = document.querySelectorAll(
            ".esri-layer-list__item-action-title"
          );
          const optionsUl = document.querySelectorAll(
            ".esri-layer-list__item-action"
          );
          const optionsIcons = document.querySelectorAll(
            ".esri-layer-list__item-action-icon"
          );
          const optionsBorder = document.querySelectorAll(
            ".esri-layer-list__item-actions-list"
          );

          const isDarkLayer = darkLayersArray.includes(newValue.title);

          setIsLightLayer(!isDarkLayer);

          listTitle.forEach((title) => {
            title.classList.toggle(
              "esri-layer-list__item-title-dark",
              !isDarkLayer
            );
          });

          listCheckboxes.forEach((checkbox) => {
            checkbox.classList.toggle(
              "esri-layer-list__item-toggle_dark",
              !isDarkLayer
            );
          });
          listChildToggle.forEach((toggle) => {
            toggle.classList.toggle(
              "esri-layer-list__child-toggle_dark",
              !isDarkLayer
            );
          });
          infoDots.forEach((dots) => {
            dots.classList.toggle(
              "esri-icon-handle-horizontal_dark",
              !isDarkLayer
            );
          });
          suggestionParents.forEach((suggestions) => {
            suggestions.classList.toggle("accordion-button_dark", !isDarkLayer);
          });

          layersName.forEach((layerN) => {
            layerN.classList.toggle(
              "esri-basemap-gallery__item-title_dark",
              !isDarkLayer
            );
          });

          optionsHeader.forEach((optionHeader) => {
            optionHeader.classList.toggle(
              "esri-layer-list__item-action-title-dark",
              !isDarkLayer
            );
          });
          optionsUl.forEach((optionsUl) => {
            optionsUl.classList.toggle(
              "esri-layer-list__item-action-dark",
              !isDarkLayer
            );
          });
          optionsIcons.forEach((optionsIcons) => {
            optionsIcons.classList.toggle(
              "esri-layer-list__item-title-dark",
              !isDarkLayer
            );
          });
          optionsBorder.forEach((optionsBorder) => {
            optionsBorder.classList.toggle(
              "esri-layer-list__item-actions-list-dark",
              !isDarkLayer
            );
          });
          navigatorComponents.forEach((navigatorComponents) => {
            if (
              location.pathname.includes("interactivemap") ||
              location.pathname.includes("map")
            ) {
              navigatorComponents.classList.toggle(
                "header-link-dark",
                !isDarkLayer
              );
            }
          });

          if (loginButton != null) {
            loginButtonText.classList.toggle("login-button-dark", !isDarkLayer);
            loginButtonIcon.classList.toggle("header-icon-dark", !isDarkLayer);
            if (location.pathname.includes("interactivemap")) {
              loginButton.classList.toggle(
                "login-button-border-dark",
                !isDarkLayer
              );
            }
          }
          const searchSettingsPopupStyle = document.getElementById(
            "searchSettingsPopup"
          );

          if (searchSettingsPopupStyle) {
            searchSettingsPopupStyle.classList.toggle(
              "searchSettingsPopupDiv-dark",
              !isDarkLayer
            );
          }
          searchTextColor.classList.toggle("searchText-dark", !isDarkLayer);
        });

        /* featurelayer Region begin */
        let featureLayersMap = {};
        var ManageMapLayersArray = [];
        var popupConfigsArray = [];
        // Fetch configuration from MapServer
        esriRequest(
          "https://gis.economy.ge/server/rest/services/TCSA/ManageMapLayersConfig/MapServer/0/query?f=pjson&where=1=1&outFields=*",
          {
            responseType: "json",
          }
        ).then((response) => {
          const layersConfig = response.data.features;
          ManageMapLayersArray = response.data.features;
          // Step 2: Filter out the unique URLs (get distinct URLs)
          const uniqueUrls = [
            ...new Set(
              layersConfig.map((layer) => layer.attributes.URL) // Assuming `Url` field holds the layer URL
            ),
          ];
          const groupLayers = {}; // Store created group layers
          // Process each URL based on whether it's a FeatureServer or MapServer
          uniqueUrls.forEach((url) => {

            const isFeatureServer = true;
            //const isFeatureServer = url.includes("/FeatureServer");
            if (url != 'test') {
              const requestUrl = isFeatureServer ? `${url}/layers?f=json` : `${url}?f=json`;


              esriRequest(requestUrl, { responseType: "json" }).then((response) => {
                if (isFeatureServer) {
                  // FeatureServer logic
                  const layers = response.data.layers;
                  const layerDetailsPromises = [];

                  // Fetch detailed info for each layer
                  layers.forEach((layer) => {
                    const layerUrl = `${url}/${layer.id}`;
                    layerDetailsPromises.push(
                      esriRequest(layerUrl + "?f=json", { responseType: "json" }).then((res) => res.data)
                    );
                  });

                  // Fetch the popup configurations from a separate service or endpoint
                  esriRequest(
                    "https://gis.economy.ge/server/rest/services/TCSA/ManageMapLayersConfig/MapServer/0/query?f=json&where=1=1&outFields=*&returnGeometry=false",
                    {
                      responseType: "json",
                    }
                  ).then((popupConfigResponse) => {
                    const popupConfigs = popupConfigResponse.data.features;
                    popupConfigsArray = popupConfigResponse.data.features;
                    // Process layer details after all requests complete
                    Promise.all(layerDetailsPromises).then((layerDetails) => {
                      const parentMap = {}; // Map to group layers by parent


                      // Organize layers by parent
                      layerDetails.forEach((layer) => {
                        const parentLayerName = layer.parentLayer ? layer.parentLayer.name : null;

                        if (parentLayerName) {
                          // Add to the parent's group
                          if (!parentMap[parentLayerName]) {
                            parentMap[parentLayerName] = [];
                          }
                          parentMap[parentLayerName].push(layer);
                        } else {
                          // Top-level layers
                          if (!parentMap["root"]) {
                            parentMap["root"] = [];
                          }
                          parentMap["root"].push(layer);
                        }
                      });
                      var featureLayer;
                      // Add root layers directly
                      if (parentMap["root"]) {
                        parentMap["root"].forEach((rootLayer) => {
                          featureLayer = new FeatureLayer({
                            url: `${url}/${rootLayer.id}`,
                            title: rootLayer.name,
                            listMode: "show", // Ensure it's visible in the LayerList
                          });
                          const testid = featureLayer.id;
                          // Check if root layer has sublayers
                          if (!rootLayer.hasOwnProperty("layers") || rootLayer.layers.length === 0) {
                            // If no sublayers, assign popupTemplate
                            const popupConfig = popupConfigs.find(
                              (config) => config.attributes.LayerId === rootLayer.id
                            );
                            if (popupConfig && popupConfig.attributes.HasPopup) {
                              const popupFields = popupConfig.attributes.PopupFields
                                ? popupConfig.attributes.PopupFields.split(",")
                                : [];
                            }
                          }
                          parentGroupLayer.layers.add(featureLayer, 0);
                          //map.add(featureLayer, 0);
                          featureLayer.visible = false;
                          featureLayersMap[rootLayer.name] = featureLayer;

                        });
                      }

                      // Create group layers for parents
                      Object.keys(parentMap).forEach((parentName) => {
                        if (parentName === "root") return; // Skip root

                        const groupLayer = new GroupLayer({
                          title: parentName,
                          visibilityMode: "independent",
                          visible: false,
                          layers: parentMap[parentName].map((childLayer) => {
                            featureLayer = new FeatureLayer({
                              url: `${url}/${childLayer.id}`,
                              title: childLayer.name,
                              // featureReduction: childLayer.geometryType === "esriGeometryPoint" ? {

                              // } : null, // Enable clustering only for point layers
                              listMode: "show", // Ensure it's visible in the LayerList
                            });
                            const testid = featureLayer.id;
                            if (testid.includes("54")) {
                              const testttt = "";
                            }
                            if (
                              childLayer.geometryType === "esriGeometryPoint" ||
                              childLayer.geometryType === "esriGeometryMultipoint"
                            ) {
                              const fetchPoints = async (featureLayerPoint) => {
                                const query = featureLayerPoint.createQuery();
                                const response = await featureLayerPoint.queryFeatures(query);
                                return response.features;
                              };
                              const addPointLayerWithClustering = async (featureLayerPoint) => {
                                const pointGraphics = await fetchPoints(featureLayerPoint);
                                if (featureLayerPoint) {
                                  const pointLayer = new FeatureLayer({
                                    url: featureLayerPoint.url + "/" + featureLayerPoint.layerId,   // აქ გადაეცემა პირდაპირ URL
                                    title: featureLayerPoint.title,
                                    outFields: ["*"],
                                    renderer: {
                                      type: "simple",
                                      symbol: {
                                        type: "simple-marker",
                                        size: 6,
                                        color: "yellow",
                                        outline: {
                                          color: "white",
                                          width: 0.5,
                                        },
                                      },
                                    },
                                    featureReduction: {
                                      type: "cluster",
                                      clusterMinSize: 16.5,
                                      clusterRenderer: {
                                        type: "simple",
                                        symbol: {
                                          type: "simple-marker",
                                          color: "orange",
                                          size: "28px",
                                          outline: {
                                            color: "white",
                                            width: 1,
                                          },
                                        },
                                        label: {
                                          type: "text",
                                          color: "white",
                                          font: {
                                            family: "Noto Sans",
                                            size: "12px",
                                          },
                                        },
                                      },
                                      labelingInfo: [
                                        {
                                          deconflictionStrategy: "none",
                                          labelExpressionInfo: {
                                            expression: "Text($feature.cluster_count, '#,###')",
                                          },
                                          symbol: {
                                            type: "text",
                                            color: "black",
                                            font: {
                                              family: "Noto Sans",
                                              size: "12px",
                                            },
                                          },
                                          labelPlacement: "center-center",
                                        },
                                      ],
                                      popupTemplate: {
                                        title: "კლასტერის მიმოხილვა",
                                        content: "კლასტერი შეიცავს <b>{cluster_count}</b> ობიექტს.",
                                        fieldInfos: [
                                          {
                                            fieldName: "cluster_count",
                                            format: {
                                              places: 0,
                                              digitSeparator: true,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                    visible: featureLayerPoint.visible, // Initialize visibility
                                  });
                                  // clustering enable/disable by scale
                                  view.watch("scale", (newScale) => {
                                    if (newScale < 150000) {
                                      pointLayer.featureReduction = null;
                                    } else {
                                      pointLayer.featureReduction = { ...pointLayer.featureReduction, type: "cluster" };
                                    }
                                  });
                                  // synch visibility
                                  featureLayerPoint.watch("visible", (newValue) => {
                                    pointLayer.visible = newValue;
                                  });

                                  let categoryPoint = '';
                                  if (featureLayerPoint.parent.title != 'დამფარავი ფენები') {
                                    categoryPoint = childLayer.parentLayer.name;
                                  } else {
                                    categoryPoint = featureLayerPoint.title;
                                  }

                                  if (groupLayers[categoryPoint]) {
                                    groupLayers[categoryPoint].watch("visible", (newValue) => {
                                      pointLayer.visible = newValue;
                                    });
                                  }

                                  pointLayer.listMode = "hide";
                                  pointLayer.visible = false;
                                  map.add(pointLayer);

                                  // clustering enable/disable by scale
                                  view.watch("scale", (newScale) => {
                                    if (newScale < 150000) {
                                      pointLayer.featureReduction = null;
                                    } else {
                                      pointLayer.featureReduction = {
                                        type: "cluster",
                                        clusterMinSize: 16.5,
                                        clusterRenderer: {
                                          type: "simple",
                                          symbol: {
                                            type: "simple-marker",
                                            color: "orange",
                                            size: "28px",
                                            outline: {
                                              color: "white",
                                              width: 1,
                                            },
                                          },
                                          label: {
                                            type: "text",
                                            color: "white",
                                            font: {
                                              family: "Noto Sans",
                                              size: "12px",
                                            },
                                          },
                                        },
                                        labelingInfo: [
                                          {
                                            deconflictionStrategy: "none",
                                            labelExpressionInfo: {
                                              expression: "Text($feature.cluster_count, '#,###')",
                                            },
                                            symbol: {
                                              type: "text",
                                              color: "black",
                                              font: {
                                                family: "Noto Sans",
                                                size: "12px",
                                              },
                                            },
                                          },
                                        ],
                                        popupTemplate: {
                                          title: "კლასტერის მიმოხილვა",
                                          content: "კლასტერი შეიცავს <b>{cluster_count}</b> ობიექტს.",
                                          fieldInfos: [
                                            {
                                              fieldName: "cluster_count",
                                              format: {
                                                places: 0,
                                                digitSeparator: true,
                                              },
                                            },
                                          ],
                                        },
                                      };
                                    }
                                  });
                                }
                              };

                              addPointLayerWithClustering(featureLayer);
                            }
                            // if (childLayer.geometryType === "esriGeometryPoint" || childLayer.geometryType === "esriGeometryMultipoint") {
                            //   //groupLayers[category].layers.add(featureLayer);
                            //   // Initial configuration for clustering
                            //   const clusteringPoint = {
                            //     type: "cluster",
                            //     clusterMinSize: 16.5,
                            //     labelingInfo: [
                            //       {
                            //         deconflictionStrategy: "none",
                            //         labelExpressionInfo: {
                            //           expression:
                            //             "Text($feature.cluster_count, '#,###')",
                            //         },
                            //         symbol: {
                            //           type: "text",
                            //           color: "white",
                            //           font: {
                            //             family: "Noto Sans",
                            //             size: "12px",
                            //           },
                            //         },
                            //         labelPlacement: "center-center",
                            //       },
                            //     ],
                            //     popupTemplate: {
                            //       title: "კლასტერის მიმოხილვა",
                            //       fieldInfos: [
                            //         {
                            //           fieldName: "cluster_count",
                            //           format: {
                            //             places: 0,
                            //             digitSeparator: true,
                            //           },
                            //         },
                            //       ],
                            //     },
                            //     visible: featureLayer.visible, // Initialize the visibility
                            //   };
                            //   // Watch the scale of the view to disable clustering when the scale is less than 10,000
                            //   view.watch("scale", function (newScale) {
                            //     if (newScale < 1500000) {
                            //       featureLayer.featureReduction = null; // Disable clustering
                            //     } else {
                            //       featureLayer.featureReduction = clusteringPoint;
                            //     }
                            //   });
                            //   //featureLayer.featureReduction = clusteringPoint;
                            // }
                            else if (childLayer.geometryType === "esriGeometryPolygon") {
                              //I პოლიგონი

                              childLayer.renderer = {
                                type: "simple", // autocasts as new SimpleRenderer()
                                symbol: {
                                  type: "simple-fill", // autocasts as new SimpleFillSymbol()
                                  color: [255, 165, 0, 0.5], // orange fill with 50% opacity
                                  outline: {
                                    color: [255, 255, 255],
                                    width: 3 // increase this to make the borders thicker
                                  }
                                }
                              };

                              const createCentroids = (features) => {
                                return features.map((feature) => {
                                  if (feature.geometry) {
                                    const centroid = feature.geometry.centroid;
                                    return new Graphic({
                                      geometry: centroid,
                                      attributes: feature.attributes,
                                    });
                                  }
                                  else {
                                    var test = "test";
                                  }
                                });
                              };

                              // Fetch polygon features and create centroid graphics
                              const fetchPolygonsAndCreateCentroids = async (featureLayerPolygon) => {
                                const query = featureLayerPolygon.createQuery();
                                const response = await featureLayerPolygon.queryFeatures(
                                  query
                                );
                                if (response.features.length > 0) {
                                  return createCentroids(response.features);
                                }
                              };

                              const addCentroidLayerWithClustering = async (featureLayerPolygon) => {
                                const centroidGraphics =
                                  await fetchPolygonsAndCreateCentroids(featureLayerPolygon);
                                if (centroidGraphics) {
                                  const centroidLayer = new FeatureLayer({
                                    source: centroidGraphics,
                                    objectIdField: "OBJECTID",
                                    outFields: ["*"],
                                    geometryType: "point",
                                    spatialReference: featureLayerPolygon.spatialReference,
                                    renderer: {
                                      type: "simple",
                                      symbol: {
                                        type: "simple-marker",
                                        size: 1, // Make the centroid markers invisible
                                        color: "yellow", // Transparent color
                                        outline: {
                                          color: "white", // Transparent outline
                                          width: 0.5,
                                        },
                                      },
                                    },
                                    featureReduction: {
                                      type: "cluster",
                                      clusterMinSize: 16.5,
                                      clusterRenderer: {
                                        type: "simple",
                                        symbol: {
                                          type: "simple-marker",
                                          color: "orange", // Change this to the desired cluster color
                                          size: "28px",
                                          outline: {
                                            color: "white",
                                            width: 1,
                                          },
                                        },
                                        label: {
                                          type: "text",
                                          color: "white",
                                          font: {
                                            family: "Noto Sans",
                                            size: "12px",
                                          },
                                        },
                                      },
                                      labelingInfo: [
                                        {
                                          deconflictionStrategy: "none",
                                          labelExpressionInfo: {
                                            expression:
                                              "Text($feature.cluster_count, '#,###')",
                                          },
                                          symbol: {
                                            type: "text",
                                            color: "black",
                                            font: {
                                              family: "Noto Sans",
                                              size: "12px",
                                            },
                                          },
                                          labelPlacement: "center-center",
                                        },
                                      ],
                                      popupTemplate: {
                                        title: "კლასტერის მიმოხილვა",
                                        content:
                                          "კლასტერი შეიცავს <b>{cluster_count}</b> ობიექტს.",
                                        // content: (feature) => {
                                        //   let content = "<ul>";
                                        //   feature.graphic.attributes.clusteredFeatures.forEach(f => {
                                        //     content += `<li>${f.attributes["obieqtis_dasaxeleba"] || "No Title"}</li>`;
                                        //   });
                                        //   content += "</ul>";
                                        //   return content;
                                        // },
                                        fieldInfos: [
                                          {
                                            fieldName: "cluster_count",
                                            format: {
                                              places: 0,
                                              digitSeparator: true,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                    visible: featureLayerPolygon.visible, // Initialize the visibility
                                  });

                                  // Synchronize visibility of centroid layer with polygon layer
                                  //map.add(fLayerI_stadia_PolygonTEST);
                                  featureLayerPolygon.watch("visible", (newValue) => {
                                    centroidLayer.visible = newValue;
                                  });
                                  //აქ ვიღებთ კატეგორიას იმიტომ რომ არ ცვლის მანამდე აღებული კატეგორია
                                  let categoryPolygon = '';
                                  if (featureLayerPolygon.parent.title != 'დამფარავი ფენები') {
                                    categoryPolygon = featureLayerPolygon.parent.title;
                                  }
                                  else {
                                    categoryPolygon = featureLayerPolygon.title;
                                  }

                                  if (groupLayers[categoryPolygon]) {
                                    // Watch visibility changes for group layers
                                    groupLayers[categoryPolygon].watch(
                                      "visible",
                                      (newValue) => {
                                        centroidLayer.visible = newValue;
                                      }
                                    );
                                  }
                                  centroidLayer.visible = false; //ჩატვირთვის დროს არ ჩანდეს
                                  map.add(centroidLayer);
                                  // Hide centroid layer from the legend
                                  centroidLayer.listMode = "hide";

                                  // Watch the scale of the view and disable clustering when the scale is less than 10,000
                                  view.watch("scale", function (newScale) {
                                    if (newScale < 150000) {
                                      centroidLayer.featureReduction = null; // Disable clustering
                                    } else {
                                      centroidLayer.featureReduction = {
                                        type: "cluster",
                                        clusterMinSize: 16.5,
                                        clusterRenderer: {
                                          type: "simple",
                                          symbol: {
                                            type: "simple-marker",
                                            color: "orange",
                                            size: "28px",
                                            outline: {
                                              color: "white",
                                              width: 1,
                                            },
                                          },
                                          label: {
                                            type: "text",
                                            color: "white",
                                            font: {
                                              family: "Noto Sans",
                                              size: "12px",
                                            },
                                          },
                                        },
                                        labelingInfo: [
                                          {
                                            deconflictionStrategy: "none",
                                            labelExpressionInfo: {
                                              expression:
                                                "Text($feature.cluster_count, '#,###')",
                                            },
                                            symbol: {
                                              type: "text",
                                              color: "black",
                                              font: {
                                                family: "Noto Sans",
                                                size: "12px",
                                              },
                                            },
                                            labelPlacement: "center-center",
                                          },
                                        ],
                                        popupTemplate: {
                                          title: "კლასტერის მიმოხილვა",
                                          content:
                                            "კლასტერი შეიცავს <b>{cluster_count}</b> ობიექტს.",
                                          fieldInfos: [
                                            {
                                              fieldName: "cluster_count",
                                              format: {
                                                places: 0,
                                                digitSeparator: true,
                                              },
                                            },
                                          ],
                                        },
                                      }; // Enable clustering
                                    }
                                  });
                                };
                              }
                              //map.add(fLayerI_stadia_PolygonTEST);
                              addCentroidLayerWithClustering(featureLayer);
                            } else if (childLayer.geometryType === "esriGeometryPolyline") {
                              // Function to calculate the midpoint of a polyline
                              const calculateMidpoint = (polyline) => {
                                let totalLength = 0;
                                const lengths = polyline.paths[0].map(
                                  (point, index, arr) => {
                                    if (index === 0) return 0;
                                    const length = Math.sqrt(
                                      Math.pow(point[0] - arr[index - 1][0], 2) +
                                      Math.pow(point[1] - arr[index - 1][1], 2)
                                    );
                                    totalLength += length;
                                    return length;
                                  }
                                );
                                const midpointLength = totalLength / 2;
                                let accumulatedLength = 0;
                                for (let i = 1; i < polyline.paths[0].length; i++) {
                                  accumulatedLength += lengths[i];
                                  if (accumulatedLength >= midpointLength) {
                                    const segmentLength = lengths[i];
                                    const remainingLength =
                                      accumulatedLength - midpointLength;
                                    const ratio = remainingLength / segmentLength;
                                    const midX =
                                      polyline.paths[0][i][0] * (1 - ratio) +
                                      polyline.paths[0][i - 1][0] * ratio;
                                    const midY =
                                      polyline.paths[0][i][1] * (1 - ratio) +
                                      polyline.paths[0][i - 1][1] * ratio;
                                    return {
                                      type: "point",
                                      x: midX,
                                      y: midY,
                                      spatialReference: polyline.spatialReference,
                                    };
                                  }
                                }
                              };

                              // Create centroids for polyline features
                              const createCentroidsLINE = (features) => {
                                return features.map((feature) => {
                                  const midpoint = calculateMidpoint(
                                    feature.geometry
                                  );
                                  return new Graphic({
                                    geometry: midpoint,
                                    attributes: feature.attributes,
                                  });
                                });
                              };

                              // Fetch polyline features and create centroid graphics
                              const fetchPolylinesAndCreateCentroidsLINE =
                                async (featureLayerLine) => {
                                  const query = featureLayerLine.createQuery();
                                  const response = await featureLayerLine.queryFeatures(
                                    query
                                  );
                                  //ალეკს if (response.features.length > 0) {
                                  if (response.features.length > 0) {
                                    return createCentroidsLINE(response.features);
                                  }
                                  // const centroids = createCentroidsLINE(
                                  //   response.features
                                  // );
                                  // return centroids;
                                };

                              // Add centroid layer with clustering
                              const addCentroidLayerWithClusteringLINE =
                                async (featureLayerLine) => {
                                  const centroidGraphics =
                                    await fetchPolylinesAndCreateCentroidsLINE(featureLayerLine);
                                  if (centroidGraphics) {
                                    const centroidLayerLINE = new FeatureLayer({
                                      source: centroidGraphics,
                                      objectIdField: "OBJECTID",
                                      outFields: ["*"],
                                      geometryType: "point",
                                      spatialReference: featureLayerLine.spatialReference,
                                      renderer: {
                                        type: "simple",
                                        symbol: {
                                          type: "simple-marker",
                                          size: 1, // Make the centroid markers invisible
                                          //style: "square", // ეს აქცევს კლასტერების წრეებს კვადრატად
                                          style: "point",
                                          color: "red", // Transparent color
                                          outline: {
                                            color: "white", // Transparent outline
                                            width: 0.5,
                                          },
                                        },
                                      },
                                      featureReduction: {
                                        type: "cluster",
                                        clusterMinSize: 16.5,
                                        clusterRenderer: {
                                          type: "simple",
                                          symbol: {
                                            type: "simple-marker",
                                            color: "orange", // Change this to the desired cluster color
                                            size: "28px",
                                            style: "square",
                                            outline: {
                                              color: "white",
                                              width: 1,
                                            },
                                          },
                                          label: {
                                            type: "text",
                                            color: "white",
                                            font: {
                                              family: "Noto Sans",
                                              size: "12px",
                                            },
                                          },
                                        },
                                        labelingInfo: [
                                          {
                                            deconflictionStrategy: "none",
                                            labelExpressionInfo: {
                                              expression:
                                                "Text($feature.cluster_count, '#,###')",
                                            },
                                            symbol: {
                                              type: "text",
                                              color: "white",
                                              font: {
                                                family: "Noto Sans",
                                                size: "12px",
                                              },
                                            },
                                            labelPlacement: "center-center",
                                          },
                                        ],
                                        popupTemplate: {
                                          title: "კლასტერის მიმოხილვა",
                                          content:
                                            "კლასტერი შეიცავს <b>{cluster_count}</b> ობიექტს.",
                                          fieldInfos: [
                                            {
                                              fieldName: "cluster_count",
                                              format: {
                                                places: 0,
                                                digitSeparator: true,
                                              },
                                            },
                                          ],
                                        },
                                        visible: featureLayerLine.visible, // Initialize the visibility
                                      },
                                      visible: featureLayerLine.visible, // Initialize the visibility
                                    });

                                    // Synchronize visibility of centroid layer with polyline layer
                                    featureLayerLine.watch("visible", (newValue) => {
                                      centroidLayerLINE.visible = newValue;
                                    });
                                    //აქ ვიღებთ კატეგორიას იმიტომ რომ არ ცვლის მანამდე აღებული კატეგორია
                                    let categoryLine = '';
                                    if (featureLayerLine.parent.title != 'დამფარავი ფენები') {
                                      categoryLine = featureLayerLine.parent.title;
                                    }
                                    else {
                                      categoryLine = featureLayerLine.title;
                                    }
                                    // Watch visibility changes for group layers
                                    if (groupLayers[categoryLine]) {
                                      groupLayers[categoryLine].watch(
                                        "visible",
                                        (newValue) => {
                                          centroidLayerLINE.visible = newValue;
                                        }
                                      );
                                    }
                                    centroidLayerLINE.visible = false;
                                    map.add(centroidLayerLINE);
                                    // Hide centroid layer from the legend
                                    centroidLayerLINE.listMode = "hide";
                                    view.watch("scale", function (newScale) {
                                      if (newScale < 150000) {
                                        centroidLayerLINE.featureReduction = null; // Disable clustering
                                      } else {
                                        centroidLayerLINE.featureReduction = {
                                          type: "cluster",
                                          clusterMinSize: 16.5,
                                          clusterRenderer: {
                                            type: "simple",
                                            symbol: {
                                              type: "simple-marker",
                                              color: "orange",
                                              size: "28px",
                                              style: "square",
                                              outline: {
                                                color: "white",
                                                width: 1,
                                              },
                                            },
                                            label: {
                                              type: "text",
                                              color: "white",
                                              font: {
                                                family: "Noto Sans",
                                                size: "12px",
                                              },
                                            },
                                          },
                                          labelingInfo: [
                                            {
                                              deconflictionStrategy: "none",
                                              labelExpressionInfo: {
                                                expression:
                                                  "Text($feature.cluster_count, '#,###')",
                                              },
                                              symbol: {
                                                type: "text",
                                                color: "white",
                                                font: {
                                                  family: "Noto Sans",
                                                  size: "12px",
                                                },
                                              },
                                              labelPlacement: "center-center",
                                            },
                                          ],
                                          popupTemplate: {
                                            title: "კლასტერის მიმოხილვა",
                                            content:
                                              "კლასტერი შეიცავს <b>{cluster_count}</b> ობიექტს.",
                                            fieldInfos: [
                                              {
                                                fieldName: "cluster_count",
                                                format: {
                                                  places: 0,
                                                  digitSeparator: true,
                                                },
                                              },
                                            ],
                                          },
                                        }; // Re-enable clustering
                                      }
                                    });
                                  };
                                }
                              addCentroidLayerWithClusteringLINE(featureLayer);
                            }
                            featureLayersMap[childLayer.name] = featureLayer;
                            // Check if the child layer has sublayers
                            if (!childLayer.hasOwnProperty("layers") || childLayer.layers.length === 0) {
                              // If no sublayers, assign popupTemplate
                              const popupConfig = popupConfigs.find(
                                (config) => config.attributes.LayerId === childLayer.id
                              );
                              if (popupConfig && popupConfig.attributes.HasPopup) {
                                const popupFields = popupConfig.attributes.PopupFields
                                  ? popupConfig.attributes.PopupFields.split(",")
                                  : [];

                                // featureLayer.popupTemplate = {
                                //   title: childLayer.name,
                                //   content: [
                                //     {
                                //       type: "fields",
                                //       fieldInfos: popupFields.map((field) => {
                                //         const [fieldName, fieldAlias] = field.split("-").map((s) => s.trim());
                                //         return { fieldName, label: fieldAlias };
                                //       }),
                                //     },
                                //   ],
                                // };
                              }
                            }

                            return featureLayer;
                          }),
                          listMode: "show", // Ensure group layer is visible in the LayerList
                        });
                        groupLayers[parentName] = groupLayer;
                        parentGroupLayer.layers.add(groupLayer, 0);
                        //map.add(groupLayer, 0);
                      });
                      let category = '';
                      if (featureLayer.parent.title != 'დამფარავი ფენები') {
                        category = featureLayer.parent.title;
                      }
                      else {
                        category = featureLayer.title;
                      }
                      //const category = sublayer.title.split(" - ")[0];
                      /*cluster config */

                      /*cluster config */

                    });

                  });
                } else {

                  // MapServer logic
                  const mapServerLayer = new FeatureLayer({
                    url: url,
                    title: response.data.name, // Use the map service name as title
                    listMode: "show",
                  });
                  map.add(mapServerLayer); // Add MapServer layer directly to the map
                }
              });
            }
          });
        });
        /* featurelayer region end  */

        // Function to recursively find a sublayer by its title within a layer or its sublayers
        function findSublayer(layer, layerName) {
          if (layer.title === layerName) {
            return layer;
          }

          if (layer.sublayers && layer.sublayers.length > 0) {
            for (let i = 0; i < layer.sublayers.length; i++) {
              const sublayer = findSublayer(
                layer.sublayers.items[i],
                layerName
              );
              if (sublayer) {
                return sublayer;
              }
            }
          }

          return null;
        }

        // Function to query sublayers
        function querySublayer(sublayerId, searchFields, searchTextValue) {
          return new Promise((resolve, reject) => {
            const query = {
              returnGeometry: true, // We need geometry to zoom to the feature
              outSpatialReference: view.spatialReference, // Use the same spatial reference as the view
              outFields: ["*"],
            };
            const searchFieldsArray = searchFields.split(",");
            const whereClause = searchFieldsArray
              .map((field) => `${field} LIKE N'%${searchTextValue}%'`)
              .join(" OR ");

            query.where = whereClause;

            var sublayer = TCSALayer.findSublayerById(sublayerId);
            if (sublayer) {
              sublayer
                .queryFeatures(query)
                .then((result) => {
                  resolve(result.features);
                })
                .catch((error) => {
                  console.error(
                    "Error querying sublayer:",
                    sublayerId,
                    error
                  );
                  reject(error);
                });
            } else {
              console.error("Sublayer not found:", sublayerId);
              resolve([]); // Resolve with an empty array if the sublayer is not found
            }
          });
        }

        // Function to process features and create accordion items
        function processFeatures(
          features,
          layerName,
          searchDisplayField,
          processedLayers,
          suggestionsDiv,
          sublayer
        ) {
          if (features.length > 0 && !processedLayers.has(layerName)) {
            processedLayers.add(layerName);

            const layerContainer = document.createElement("div");
            layerContainer.className = "accordion-item";

            const layerHeading = document.createElement("button");
            layerHeading.className = "accordion-button";
            layerHeading.textContent = `${layerName} (${features.length})`;
            layerHeading.addEventListener("click", function () {
              this.classList.toggle("active");
              const panel = this.nextElementSibling;
              if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
              } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
              }
            });
            layerContainer.appendChild(layerHeading);

            const panel = document.createElement("div");
            panel.className = "accordion-panel";

            features.forEach(function (feature) {
              const suggestion = document.createElement("p");
              suggestion.textContent =
                feature.attributes[searchDisplayField];
              suggestion.addEventListener("click", function () {
                searchText.value = feature.attributes[searchDisplayField];
                suggestionsDiv.style = "visibility:hidden";
                if (sublayer) {
                  sublayer.visible = true;
                  const parentLayer = findParentLayer(
                    parentGroupLayer,
                    sublayer
                  );
                  if (parentLayer) {
                    parentLayer.visible = true;
                  }
                }
                zoomToFeature(feature);
              });
              panel.appendChild(suggestion);
            });

            layerContainer.appendChild(panel);
            suggestionsDiv.appendChild(layerContainer);

            if (features.length <= 10) {
              layerHeading.classList.add("active");
              panel.style.maxHeight = panel.scrollHeight + "px";
            } else {
              suggestionsDiv.style.maxHeight = null;
            }
          }
        }

        // Function to perform search and update suggestions
        async function performSearchAndUpdateSuggestions(
          zoomToResults = false
        ) {

          const searchTextValue = searchText.value.trim();

          if (searchTextValue === "") {
            suggestionsDiv.innerHTML = "";
            clearSearchButton.style = "visibility:hidden";
            ManageMapLayersArray.forEach(function (Fena) {
              if (Fena.attributes.URL != null) {
                const featureLayer = featureLayersMap[Fena.attributes.LayerName];
                if (featureLayer) {
                  featureLayer.definitionExpression = null;
                }
              }
            });
            return;
          }
          suggestionsDiv.innerHTML = '<div class="horizontal-search-loader"><div></div><div></div><div></div></div>';
          //suggestionsDiv.innerHTML = "searching";
          const processedLayers = new Set();
          const allFeatures = [];
          var hideLoader = true;
          for (const Fena of ManageMapLayersArray) {
            if (
              Fena.attributes.URL != null &&
              Fena.attributes.SearchFields &&
              sessionStorage.getItem("sakadastroLayerChecked") !== "false"
            ) {
              //თუ გამორთულია საკადასტრო ფენები სეთინგებში მაშინ არ მოძებნის
              const featureLayer = featureLayersMap[Fena.attributes.LayerName];
              if (!featureLayer) continue;

              const query = {
                returnGeometry: true,
                outSpatialReference: view.spatialReference,
                outFields: ["*"],
                resultRecordCount: 100, //// Limit the number of records fetched
                cacheHint: true, // Enables caching for repeated queries
              };
              if (Fena.attributes.SearchFields) {
                const searchFieldsArray = Fena.attributes.SearchFields.split(",");
                const whereClause = searchFieldsArray
                  .map((field) => `${field} LIKE N'%${searchTextValue}%'`)
                  .join(" OR ");

                query.where = whereClause;

                featureLayer.definitionExpression = whereClause;
                if (featureLayer.title.toLowerCase() === 'საკადასტრო მონაცემები') {
                  const dotCount = searchTextValue.split('.').length - 1; // Count the number of dots
                  if (dotCount >= 3) {
                    const response = await featureLayer.queryFeatures(query);
                    const features = response.features;
                    allFeatures.push(...features);
                    if (features.length > 0) {
                      if (hideLoader) {
                        suggestionsDiv.innerHTML = "";
                      }
                      hideLoader = false;

                      //featureLayer.visible = true;
                      processFeatures(
                        features,
                        Fena.attributes.LayerName,
                        Fena.attributes.SearchDisplayField,
                        processedLayers,
                        suggestionsDiv,
                        featureLayer
                      );
                    }
                    else {
                      featureLayer.definitionExpression = null; // Reset the filter
                    }
                  }
                }
                else {
                  const responseTest = Fena.attributes.LayerName;
                  const response = await featureLayer.queryFeatures(query);
                  const features = response.features;
                  allFeatures.push(...features);
                  if (features.length > 0) {
                    if (hideLoader) {
                      suggestionsDiv.innerHTML = "";
                    }
                    hideLoader = false;

                    //featureLayer.visible = true;
                    processFeatures(
                      features,
                      Fena.attributes.LayerName,
                      Fena.attributes.SearchDisplayField,
                      processedLayers,
                      suggestionsDiv,
                      featureLayer
                    );
                  }
                  else {
                    featureLayer.definitionExpression = null; // Reset the filter
                  }
                }
              }
            } else {
              const sublayer = findSublayer(TCSALayer, Fena.attributes.LayerName);
              if (
                sublayer &&
                Fena.attributes.SearchFields &&
                sessionStorage.getItem("tcsaLayerChecked") !== "false"
              ) {
                // თუ გამორთულია ტაქსას ფენები სეთინგებში მაშინ არ მოძებნის
                // ვამოწმებთ თუ აქვს ძიების ველები შევსებული
                const features = await querySublayer(
                  sublayer.id,
                  Fena.attributes.SearchFields,
                  searchTextValue
                );
                allFeatures.push(...features);
                processFeatures(
                  features,
                  Fena.attributes.LayerName,
                  Fena.attributes.SearchDisplayField,
                  processedLayers,
                  suggestionsDiv,
                  sublayer
                );
              }
            }
          }

          if (zoomToResults && allFeatures.length > 0) {
            zoomToAllFeatures(allFeatures);
          }
          if (hideLoader) {
            suggestionsDiv.innerHTML = "არაფერი მოიძებნა";
          }
        }

        // Function to zoom to a single feature
        function zoomToFeature(feature) {
          if (feature.geometry.extent) {
            view
              .goTo(feature.geometry.extent.expand(2))
              .catch(function (error) {
                console.error("Error zooming to feature:", error);
              });
          } else {
            view
              .goTo({
                target: feature.geometry,
                zoom: 20, // Adjust the zoom level as needed
              })
              .catch(function (error) {
                console.error("Error zooming to feature:", error);
              });
          }
        }
        // Function to zoom to all features
        function zoomToAllFeatures(features) {
          const geometries = features.map((feature) => feature.geometry);
          if (geometryEngine
            .union(geometries)
            .extent) {


            const combinedExtent = geometryEngine
              .union(geometries)
              .extent.expand(2);
            view.goTo(combinedExtent).catch(function (error) {
              console.error("Error zooming to all features:", error);
            });
          }
        }

        // Debounce function to delay the execution of search
        function debounce(func, delay) {
          let debounceTimeout;
          return function (...args) {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(
              () => func.apply(this, args),
              delay
            );
          };
        }
        const suggesionDivcolor = document.querySelectorAll(".accordion-button");
        const debounceDelay = 300; // Delay in milliseconds
        const debouncedPerformSearch = debounce(
          () => performSearchAndUpdateSuggestions(false),
          debounceDelay,

          suggesionDivcolor.forEach((button) => {
            button.style.color = "black";
          })
        );

        var searchButton = document.getElementById("searchButton");
        // Add a search listener to the search button
        searchButton.addEventListener("click", () =>
          performSearchAndUpdateSuggestions(true)
        );

        // // Wait 500ms after clicking button
        // let searchTimeout;
        // searchButton.addEventListener("click", function () {
        //   clearTimeout(searchTimeout);
        //   searchTimeout = setTimeout(() => {
        //     performSearchAndUpdateSuggestions();
        //   }, 500);
        // });

        const searchText = document.getElementById("searchText");
        // Add an input listener to the search text input field
        searchText.addEventListener("click", debouncedPerformSearch);
        searchText.addEventListener("input", debouncedPerformSearch);
        searchText.addEventListener("click", function (event) {
          const searchSettingsPopupDiv = document.getElementById(
            "searchSettingsPopup"
          );
          if (searchSettingsPopupDiv != null) {
            searchSettingsPopupDiv.style.visibility = "hidden";
            closeSearchSettingsPopup();
          }
          if (searchText.value != "") {
            //სერჩის ქლიქზე ვმალავთ სეთინგების პოპაფს
            suggestionsDiv.style = "visibility:visible";
          }
          suggestionsDiv.style.color = isLightLayer ? "black" : "white";
        });
        var clearSearchButton = document.getElementById("clearSearchButton");
        searchText.addEventListener("input", function (event) {

          //სერჩის ქლიქზე ვმალავთ სეთინგების პოპაფს
          const searchSettingsPopupDiv = document.getElementById(
            "searchSettingsPopup"
          );
          if (searchSettingsPopupDiv != null) {
            searchSettingsPopupDiv.style.visibility = "hidden";
            closeSearchSettingsPopup();
          }
          if (searchText.value != "") {
            clearSearchButton.style = "visibility:visible";
            suggestionsDiv.style = "visibility:visible";
          }
          else {
            clearSearchButton.style = "visibility:hidden";
          }
        });
        // Add keypress event listener to trigger search on "Enter" key
        searchText.addEventListener("keypress", function (event) {
          if (event.key === "Enter") {
            event.preventDefault(); // Prevent form submission (if inside a form)
            performSearchAndUpdateSuggestions(true);
          }
        });

        // Add click event listener to the clear button
        clearSearchButton.addEventListener("click", clearSearch);

        async function clearSearch() {
          suggestionsDiv.innerHTML = "";
          searchText.value = "";
          clearSearchButton.style = "visibility:hidden";
          ManageMapLayersArray.forEach(function (Fena) {
            if (Fena.attributes.URL != null) {
              const featureLayer = featureLayersMap[Fena.attributes.LayerName];
              if (featureLayer) {
                featureLayer.definitionExpression = null;
              }
            }
          });
        }


        /* uncomment*/
        // Add a click event listener to the map
        var identifyUrl =
          "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphics/MapServer/identify";
        // Add a click event listener to the map
        view.on("click", function (event) {
          suggestionsDiv.style = "visibility:hidden";
          const searchSettingsPopupDiv = document.getElementById(
            "searchSettingsPopup"
          );
          if (searchSettingsPopupDiv != null) {
            searchSettingsPopupDiv.style.visibility = "hidden";
            closeSearchSettingsPopup();
          }

          // Get the coordinates of the click event
          var clickPoint = event.mapPoint;

          // Set up the parameters for the Identify operation
          var identifyParams = {
            f: "json",
            tolerance: 3,
            returnGeometry: true,
            geometry: JSON.stringify({
              x: clickPoint.x,
              y: clickPoint.y,
              spatialReference: { wkid: clickPoint.spatialReference.wkid },
            }),
            mapExtent: JSON.stringify({
              xmin: view.extent.xmin,
              ymin: view.extent.ymin,
              xmax: view.extent.xmax,
              ymax: view.extent.ymax,
              spatialReference: { wkid: view.extent.spatialReference.wkid },
            }),
            imageDisplay: JSON.stringify({
              height: view.height,
              width: view.width,
              dpi: 96,
            }),
            layers: "all",
            layerDefs: "",
            time: "",
            layerTimeOptions: "",
            dynamicLayers: "",
            returnZ: false,
            returnM: false,
            gdbVersion: "",
            returnUnformattedValues: false,
          };

          // Make the Identify request using esri/request
          esriRequest(identifyUrl, {
            query: identifyParams,
            responseType: "json",
          })
            .then(function (response) {
              // Process the result, which contains information about identified features
              // You can do something with the result here
            })
            .catch(function (error) { });
        });
        // Set the activeView to the 2D MapView

        // Create an instance of the Track widget
        // and add it to the view's UI
        const track = new Track({
          view: view,
        });
        let compass = new Compass({
          view: view
        });
        // დაელოდე, სანამ DOM გამოჩნდება და მერე შეცვალე title
        view.when(() => {
          const interval = setInterval(() => {
            const compassButton = document.querySelector(".esri-compass__icon");

            if (compassButton) {
              clearInterval(interval);
              compassButton.setAttribute("title", t("კომპასი")); // ← შენი hover ტექსტი
            }
          }, 300);
        });
        let activeView = view;
        if (window.innerWidth < 768) {
          view.ui.move("zoom", "bottom-right");
          view.ui.add(track, "bottom-right");
          view.ui.add(compass, "bottom-right")
          const InteractiveMappanel = document.getElementById('InteractiveMap'); // Assuming this is your panel's ID
          InteractiveMappanel.classList.add('InteractiveMap_blur-active');

        } else {
          view.ui.move("zoom", "top-left");
          view.ui.add(track, "top-left");
          view.ui.add(compass, "top-left")
        }

        // Observe #legendExpandDiv for changes
        const observerLegend = new MutationObserver(() => adjustLegendExpandWidget());
        const legendExpandDiv = document.getElementById('legendExpandDiv');

        if (legendExpandDiv) {
          observerLegend.observe(legendExpandDiv, { childList: true, subtree: true });
        }
        // Run on page load and when resizing
        adjustLegendExpandWidget();
        function adjustLegendExpandWidget() {
          const legendExpand = document.querySelector('#legendExpandDiv .esri-expand');
          if (legendExpand) {
            if (window.innerWidth < 768) {
              legendExpand.classList.remove('esri-expand--auto');
            } else {
              legendExpand.classList.add('esri-expand--auto');
            }
          }
        }



        // Also adjust on resize
        window.addEventListener("resize", adjustLegendExpandWidget);
        window.addEventListener("resize", () => updateZoomPosition(view));
        function adjustLegendExpandWidget() {
          const legendExpand = document.querySelector('#legendExpandDiv .esri-expand');
          if (legendExpand) {
            if (window.innerWidth < 768) { // Adjust the breakpoint if needed
              legendExpand.classList.remove('esri-expand--auto');
            } else {
              legendExpand.classList.add('esri-expand--auto');
            }
          }
        }



        // Function to set the position of the zoom buttons
        function updateZoomPosition(view) {
          if (window.innerWidth < 768) {
            view.ui.move("zoom", "bottom-right");
            view.ui.move(track, "bottom-right");
          } else {
            view.ui.move("zoom", "top-left");
            view.ui.add(track, "top-left");
          }
        }



        let loadedLayersCount = 0;
        ///////aqane
        view.when(() => {
          // const legend = new Legend({
          //   view: view,
          //   layerInfos: []
          // });

          // // Add each layer from the map to the legend
          // map.layers.forEach((layer) => {
          //   // If the layer is a GroupLayer, include all of its sublayers
          //   if (layer.type === "group") {
          //     layer.layers.forEach((subLayer) => {
          //       legend.layerInfos.push({
          //         layer: subLayer,
          //         title: subLayer.title || "Untitled Layer"
          //       });
          //     });
          //   } else {
          //     legend.layerInfos.push({
          //       layer: layer,
          //       title: layer.title || "Untitled Layer"
          //     });
          //   }
          // });

          // Add the legend to the view
          //view.ui.add(legend, "bottom-right");
          // Use a small delay to ensure UI elements are rendered
          setTimeout(() => {
            const zoomInButton = document.querySelector(
              ".esri-widget--button[title='Zoom in']"
            );
            if (zoomInButton) {
              zoomInButton.title = `${t("მიახლოება")}`;
              // Zoom in translation
            }

            const zoomOutButton = document.querySelector(
              ".esri-widget--button[title='Zoom out']"
            );
            if (zoomOutButton) {
              zoomOutButton.title = `${t("დაშორება")}`; // Zoom out translation
            }
            const trackButton = document.querySelector(
              ".esri-widget--button[title='Start tracking my location']"
            );
            if (trackButton) {
              trackButton.title = `${t("მაჩვენე ჩემი მდებარეობა")}`; // Track my location translation
            }
            const expandButton = document.querySelector(
              ".esri-widget--button[title='Expand']"
            );
            if (expandButton) {
              expandButton.title = `${t("რუკის დიზაინები")}`; // Expand translation
            }
          }, 500); // Adjust delay if needed

          //aoleks
          // ეშვება მას შემდეგ რაც რუკაზე ფენები დაემატება

          view.on("layerview-create", (event) => {
            var theURL =
              "https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphics/MapServer/legend";


            esriRequest(theURL, {
              query: {
                f: "json",
              },
              responseType: "json",
            }).then(function (response) {
              if (loadedLayersCount < 1)
                layerList = new LayerList({
                  view: view,
                  container: "layerListPanel",
                  listItemCreatedFunction: function (event) {
                    const item = event.item;
                    if (item.layer.id != 0) {
                      if (item.title === "დამფარავი ფენები") {
                        // item.title = "დამფარავი ფენები";
                        item.open = true; // Expand the group layer
                      }
                      event.item.layer.opacity = 1; //added opacity here, was set to undefined
                      if (item.title != "დამფარავი ფენები") {
                        //let theArray = [];
                        var aDiv = document.createElement("Div");

                        var layerNumber = -1;
                        for (let i = 0; i < response.data.layers.length; i++) {
                          if (response.data.layers[i].layerId === item.layer.layerId) {
                            layerNumber = i;
                          }
                        }
                        if (layerNumber != -1) {
                          for (
                            let j = 0;
                            j < response.data.layers[layerNumber].legend.length;
                            j++
                          ) {



                            // if (item.layer.renderer) {
                            //   const renderer = item.layer.renderer;

                            //   // If it's a simple or unique value renderer, retrieve the symbol
                            //   if (renderer.type === "simple" || renderer.type === "uniqueValue") {
                            //     const symbol = renderer.symbol;

                            //     // Create a new <p> element for the symbol
                            //     var para = document.createElement("P");
                            //     para.style.margin = "2px";
                            //     para.style.verticalAlign = "middle";

                            //     // Handle the case for a simple symbol
                            //     if (symbol && symbol.url) {
                            //       // If it's a picture marker symbol
                            //       var img = document.createElement("img");
                            //       img.style.height = "20px";
                            //       img.style.verticalAlign = "bottom";
                            //       img.src = symbol.url;  // Use the symbol's URL for the image source
                            //       para.appendChild(img);
                            //     } else if (symbol && symbol.type === "simple-marker") {
                            //       // Handling SimpleMarkerSymbol (for circles, squares, etc.)
                            //       var div = document.createElement("div");
                            //       div.style.width = "20px";
                            //       div.style.height = "20px";

                            //       // Check for the style of the symbol (e.g., circle, square, etc.)
                            //       if (symbol.style === "circle") {
                            //         div.style.borderRadius = "50%"; // Circle style
                            //         div.style.backgroundColor = symbol.color ? symbol.color.toHex() : "gray"; // Use the symbol color
                            //         if (symbol.outline) {
                            //           div.style.border = `${symbol.outline.width || 2}px solid ${symbol.outline.color ? symbol.outline.color.toHex() : "black"}`;
                            //         }
                            //       } else if (symbol.style === "square") {
                            //         div.style.backgroundColor = symbol.color ? symbol.color.toHex() : "gray"; // Square style
                            //         if (symbol.outline) {
                            //           div.style.border = `${symbol.outline.width || 2}px solid ${symbol.outline.color ? symbol.outline.color.toHex() : "black"}`;
                            //         }
                            //       } else if (symbol.style === "triangle") {
                            //         div.style.width = "0";
                            //         div.style.height = "0";
                            //         div.style.borderLeft = "10px solid transparent";
                            //         div.style.borderRight = "10px solid transparent";
                            //         div.style.borderBottom = `20px solid ${symbol.color ? symbol.color.toHex() : "gray"}`; // Triangle style
                            //         if (symbol.outline) {
                            //           div.style.borderTop = `${symbol.outline.width || 2}px solid ${symbol.outline.color ? symbol.outline.color.toHex() : "black"}`;
                            //         }
                            //       } else {
                            //         div.style.backgroundColor = symbol.color ? symbol.color.toHex() : "gray"; // Fallback color for other styles
                            //       }

                            //       div.style.verticalAlign = "bottom";
                            //       para.appendChild(div);
                            //     } else {
                            //       // Fallback handling for other types of symbols
                            //       var div = document.createElement("div");
                            //       div.style.width = "20px";
                            //       div.style.height = "20px";
                            //       div.style.backgroundColor = symbol.color ? symbol.color.toHex() : "gray"; // Fallback color
                            //       div.style.verticalAlign = "bottom";
                            //       para.appendChild(div);
                            //     }

                            //     // Get the label for the symbol
                            //     const theLabel = response.data.layers[layerNumber].legend[j].label;
                            //     var t = document.createTextNode(theLabel);
                            //     para.appendChild(t);

                            //     // Append the <p> to the container div
                            //     aDiv.appendChild(para);

                            //     // Handle unique value renderer
                            //     if (renderer.type === "uniqueValue") {
                            //       const uniqueValues = renderer.uniqueValueInfos;
                            //       uniqueValues.forEach((valueInfo) => {
                            //         const uniqueSymbol = valueInfo.symbol;

                            //         // Create a new <p> element for each unique symbol
                            //         var uniquePara = document.createElement("P");
                            //         uniquePara.style.margin = "2px";
                            //         uniquePara.style.verticalAlign = "middle";

                            //         // Handle picture markers
                            //         if (uniqueSymbol && uniqueSymbol.url) {
                            //           var uniqueImg = document.createElement("img");
                            //           uniqueImg.style.height = "20px";
                            //           uniqueImg.style.verticalAlign = "bottom";
                            //           uniqueImg.src = uniqueSymbol.url;
                            //           uniquePara.appendChild(uniqueImg);
                            //         } else if (uniqueSymbol && uniqueSymbol.type === "simple-marker") {
                            //           // Handle simple marker symbols
                            //           var uniqueDiv = document.createElement("div");
                            //           uniqueDiv.style.width = "20px";
                            //           uniqueDiv.style.height = "20px";

                            //           // Handle circle, square, triangle styles for unique values
                            //           if (uniqueSymbol.style === "circle") {
                            //             uniqueDiv.style.borderRadius = "50%";
                            //             uniqueDiv.style.backgroundColor = uniqueSymbol.color ? uniqueSymbol.color.toHex() : "gray";
                            //             if (uniqueSymbol.outline) {
                            //               uniqueDiv.style.border = `${uniqueSymbol.outline.width || 2}px solid ${uniqueSymbol.outline.color ? uniqueSymbol.outline.color.toHex() : "black"}`;
                            //             }
                            //           } else if (uniqueSymbol.style === "square") {
                            //             uniqueDiv.style.backgroundColor = uniqueSymbol.color ? uniqueSymbol.color.toHex() : "gray";
                            //             if (uniqueSymbol.outline) {
                            //               uniqueDiv.style.border = `${uniqueSymbol.outline.width || 2}px solid ${uniqueSymbol.outline.color ? uniqueSymbol.outline.color.toHex() : "black"}`;
                            //             }
                            //           } else if (uniqueSymbol.style === "triangle") {
                            //             uniqueDiv.style.width = "0";
                            //             uniqueDiv.style.height = "0";
                            //             uniqueDiv.style.borderLeft = "10px solid transparent";
                            //             uniqueDiv.style.borderRight = "10px solid transparent";
                            //             uniqueDiv.style.borderBottom = `20px solid ${uniqueSymbol.color ? uniqueSymbol.color.toHex() : "gray"}`;
                            //             if (uniqueSymbol.outline) {
                            //               uniqueDiv.style.borderTop = `${uniqueSymbol.outline.width || 2}px solid ${uniqueSymbol.outline.color ? uniqueSymbol.outline.color.toHex() : "black"}`;
                            //             }
                            //           } else {
                            //             uniqueDiv.style.backgroundColor = uniqueSymbol.color ? uniqueSymbol.color.toHex() : "gray";
                            //           }

                            //           uniqueDiv.style.verticalAlign = "bottom";
                            //           uniquePara.appendChild(uniqueDiv);
                            //         } else {
                            //           var uniqueDiv = document.createElement("div");
                            //           uniqueDiv.style.width = "20px";
                            //           uniqueDiv.style.height = "20px";
                            //           uniqueDiv.style.backgroundColor = uniqueSymbol.color ? uniqueSymbol.color.toHex() : "gray";
                            //           uniqueDiv.style.verticalAlign = "bottom";
                            //           uniquePara.appendChild(uniqueDiv);
                            //         }

                            //         // Label for the unique value
                            //         const uniqueLabel = valueInfo.value;
                            //         var uniqueLabelText = document.createTextNode(uniqueLabel);
                            //         uniquePara.appendChild(uniqueLabelText);

                            //         // Append the <p> element with the unique symbol and label to the container div
                            //         aDiv.appendChild(uniquePara);
                            //       });
                            //     }
                            //   }
                            // }



                            // var para = document.createElement("P");
                            // para.style.margin = "2px";
                            // para.style.verticalAlign = "middle";

                            // var img = document.createElement("img");
                            // img.style.height = "20px";
                            // img.style.verticalAlign = "bottom";
                            // img.src =
                            //   "https://tcsa.tacsa.gov.ge/DotNet/proxy.ashx?" +
                            //   item.layer.url +
                            //   "/images/" +
                            //   response.data.layers[layerNumber].legend[j].url;

                            // var theLabel =
                            //   response.data.layers[layerNumber].legend[j].label;
                            // var t = document.createTextNode(theLabel);

                            // para.appendChild(img);
                            // para.appendChild(t);
                            // aDiv.appendChild(para);
                          }

                          // item.panel = {
                          //   className: "esri-icon-drag-horizontal",
                          //   content: aDiv,
                          //   open: false,
                          //   visible: true,
                          // };
                        } // if(layerNumber != -1){

                        item.actionsSections = [
                          [
                            {
                              title: "ფენის ინფორმაცია", // Existing action
                              className: "esri-icon-description",
                              id: "information",
                            },
                          ],
                          [
                            {
                              title: "გამჭვირვალობის გაზრდა", // Existing action
                              className: "esri-icon-up",
                              id: "increase-opacity",
                            },
                            {
                              title: "გამჭვირვალობის შემცირება", // Existing action
                              className: "esri-icon-down",
                              id: "decrease-opacity",
                            },
                          ],
                          [
                            {
                              title: "ოფციები", // Translated to "Options" in Georgian
                              className: "esri-icon-settings", // Adjust this if necessary to match the correct icon for options
                              id: "options", // You can give this an appropriate ID if needed
                            },
                          ],
                        ];
                        setTimeout(function () {
                          // Find the element with the "options" class and modify the title directly
                          const optionsButton = document.querySelectorAll(
                            ".esri-icon-handle-horizontal"
                          );
                          optionsButton.forEach((element) => {
                            if (element) {
                              element.setAttribute("title", "ოფციები"); // Update hover text
                            }
                          });
                        }, 100);
                      } //if (item.chil
                      else {
                        // added this so users can turn off group layers by clicking on the name
                        item.layer.watch("visible", function () {
                          item.layer.visible = true;
                        });
                      }
                    }
                  }, // listItem
                  layerInfos: [
                    {
                      layer: TCSALayer,
                      title: "USA MapImageLayer",
                      id: "USA MapImageLayer",
                      open: true,
                    },
                  ],
                }); // new layerlist
              loadedLayersCount++;
            }); // then(function (response
          });
        });
        // Set-up event handlers for buttons and click events
        const distanceButton = document.getElementById("distance");
        const areaButton = document.getElementById("area");
        const clearButton = document.getElementById("clear");

        distanceButton.addEventListener("click", () => {
          distanceMeasurement();
          // თარგმნა
          const observer = new MutationObserver(function (
            mutationsList,
            observer
          ) {
            const instructionText = document.querySelector(
              ".esri-distance-measurement-2d__hint-text"
            );
            if (instructionText) {
              instructionText.textContent =
                "გთხოვთ დააკლიკოთ რუკაზე რათა დაიწყოთ გაზომვა.";
              observer.disconnect(); // Stop observing after the text is modified
            }

            // Listen for area measurement completion to translate the button text
            view.on("click", function () {
              setTimeout(function () {
                // Add a delay to wait for the button to be added to the DOM
                const clearButton = document.querySelector(
                  ".esri-distance-measurement-2d__clear-button.esri-button.esri-button--primary"
                );
                if (clearButton) {
                  clearButton.textContent = "ახალი გაზომვა";
                }
              }, 500); // Adjust the delay time if necessary
            });
          });

          // Start observing the measurement widget's container for child elements
          observer.observe(measurement.domNode, {
            childList: true,
            subtree: true,
          });
        });
        areaButton.addEventListener("click", () => {
          areaMeasurement();
          // თარგმნა
          const observer = new MutationObserver(function (
            mutationsList,
            observer
          ) {
            const instructionText = document.querySelector(
              ".esri-area-measurement-2d__hint-text"
            );
            if (instructionText) {
              instructionText.textContent =
                "გთხოვთ დააკლიკოთ რუკაზე რათა დაიწყოთ გაზომვა.";
              observer.disconnect(); // Stop observing after the text is modified
            }

            // Listen for area measurement completion to translate the button text
            view.on("click", function () {
              setTimeout(function () {
                // Add a delay to wait for the button to be added to the DOM
                const clearButton = document.querySelector(
                  ".esri-area-measurement-2d__clear-button.esri-button.esri-button--primary"
                );
                if (clearButton) {
                  clearButton.textContent = "ახალი გაზომვა";
                }
              }, 500); // Adjust the delay time if necessary
            });
          });

          // Start observing the measurement widget's container for child elements
          observer.observe(measurement.domNode, {
            childList: true,
            subtree: true,
          });
        });
        clearButton.addEventListener("click", () => {
          clearMeasurements();
        });

        // ვინახავთ პოპაპ თემფლითებს და გვაქვს ღილაკი ჩავრთოთ თუ გამოვრთოთ პოპაფის ჩვენება რუკაზე
        // Store the original popup templates

        var infoButton = document.getElementById("infoButton");
        var popupsEnabled = false; // This is your global variable
        var originalPopupTemplates = {}; // Store original popup templates

        function setpopupsEnabled(newValue) {
          popupsEnabled = newValue; // Update the global state
        }

        function updateInfoButtonStyle() {
          if (popupsEnabled) {
            infoButton.classList.remove("info-button-disabled");
            infoButton.classList.add("info-button-enabled");
            document.body.style.cursor = `help`;
          } else {
            infoButton.classList.remove("info-button-enabled");
            infoButton.classList.add("info-button-disabled");
            document.body.style.cursor = "pointer";
          }
        }

        // Handle click event for the info button
        infoButton.addEventListener("click", function () {
          // Toggle the popupsEnabled state
          var popupsEnablednew = !popupsEnabled;
          setpopupsEnabled(popupsEnablednew);

          // Toggle the popup templates for each map layer
          view.map.layers.forEach(function (layer) {
            if (popupsEnablednew) {
              if (originalPopupTemplates[layer.id]) {
                layer.popupTemplate = originalPopupTemplates[layer.id];
              }
            } else {
              if (!originalPopupTemplates[layer.id]) {
                originalPopupTemplates[layer.id] = layer.popupTemplate;
              }
              layer.popupTemplate = null;
            }
          });

          // Update the button title and style based on the state
          infoButton.title = popupsEnablednew
            ? t("არ გამოაჩინო ფენის პოპაპები") // Disable Layer Popups
            : t("გამოაჩინე ფენის პოპაპები"); // Enable Layer Popups

          updateInfoButtonStyle(); // Update button styles after the change
        });

        // Initial style update when the page loads
        updateInfoButtonStyle();

        view.when(function () {
          // executeIdentify() is called each time the view is clicked
          view.on("click", executeIdentify);

          // Set the parameters for the identify
          params = new IdentifyParameters();
          params.tolerance = 3;
          params.layerIds = [0, 1, 2, 3, 4];
          params.layerOption = "all";
          params.width = view.width;
          params.height = view.height;
        });
        function executeIdentify(event) {
          // Set the geometry to the location of the view click
          params.geometry = event.mapPoint;
          params.mapExtent = view.extent;
          //document.getElementById("viewDiv").style.cursor = "wait";
          // this.mapRef.current.style.cursor = "wait";
          // This function returns a promise that resolves to an array of features
          // A custom popupTemplate is set for each feature based on the layer it
          // originates from
          identify
            .identify(identifyURLTCSALayer, params)
            .then(async function (response) {
              const results = response.results;

              return results.map(function (result) {
                let feature = result.feature;
                let layerName = result.layerName;

                feature.attributes.layerName = layerName;
                ManageMapLayersArray.forEach(
                  async (Fena) => {
                    if (Fena.attributes.URL == null) {
                      // if (layerName === Fena.LayerName) {
                      //const gancxadebis_nomeri = feature.attributes.gancxadebis_nomeri;
                      // Optional: Handle popup fields if needed
                      // if (Fena.HasPopup && Fena.URL == null) {
                      //   feature.popupTemplate = {
                      //     title: Fena.LayerName,
                      //     content: [{
                      //       type: "fields",
                      //       fieldInfos: Fena.PopupFields.split(',').map(field => {
                      //         const [fieldName, fieldAlias] = field.split('-').map(s => s.trim());
                      //         return {
                      //           fieldName: fieldName,
                      //           label: fieldAlias
                      //         };
                      //       })
                      //     }]
                      //   };
                      // }
                      //                     // // Show popup at the clicked location
                      // view.popup.open({
                      //   location: event.mapPoint,
                      //   features: [feature]
                      // });
                      // // API ის გამოძახება პოპაფისთვის დატას წამოსაღებად
                      // try {
                      //   const params = {
                      //     CaseNumber: gancxadebis_nomeri,
                      //   };
                      //   const response = await axios.get(`${baseURL}/GetCaseSharedDetailsByCaseNumber`, { params });
                      //   const data = response.data.data;
                      //   // Update popup template content
                      //   let content = "";
                      //   if (data != null) {
                      //     const popupTemplateTCSALayer = new PopupTemplate({
                      //       content: "" // Placeholder content, will be updated in the loop
                      //     });
                      //     data.result.forEach(result => {
                      //       content += "<b>" + result.key + ": </b>" + result.value + "<br>";
                      //     });
                      //     content += "<a href='" + baseURL.replace("/api", '') + "/caseinfo?id=" + data.result[0].caseId + "' target='_blank'>ლინკი: " + gancxadebis_nomeri + "</a>";
                      //     // Update popup template with new content
                      //     popupTemplateTCSALayer.title = feature.title;
                      //     popupTemplateTCSALayer.content = content;
                      //     // // // Show popup at the clicked location
                      //     // view.popup.open({
                      //     //   location: event.mapPoint,
                      //     //   features: [feature]
                      //     // });
                      //     feature.popupTemplate = {
                      //       // autocasts as new PopupTemplate()
                      //       title: layerName,
                      //       content: content
                      //     };
                      //     // // Add event listener to select feature when popup opens
                      //     // view.popup.once("trigger-action", function (event) {
                      //     //   // Assuming you have access to map and layers
                      //     //   // Here, 'layer' is the layer containing the selected feature
                      //     //   TCSALayer.selectFeatures([feature]);
                      //     // });
                      //     // feature.popupTemplate = {
                      //     //   // autocasts as new PopupTemplate()
                      //     //   title: layerName,
                      //     //   content: content
                      //     // };
                      //     view.openPopup({
                      //       features: results.map(result => result.feature),
                      //       location: event.mapPoint
                      //     });
                      //   }
                      // } catch (error) {
                      // }
                      // feature.popupTemplate = {
                      //   // autocasts as new PopupTemplate()
                      //   title: layerName,
                      //   content:
                      //     "<b>Block ID:</b> {BLOCK_ID} " +
                      //     "<br><b>Geometry Type:</b> {Shape}" +
                      //     "<br><b>Road Length:</b> {Shape_Length}"
                      //};
                    }
                  }
                  //}
                  //}
                );

                return feature;
              });
            })
            .then(showPopup); // Send the array of features to showPopup()
          // Shows the results of the identify in a popup once the promise is resolved
          function showPopup(response) {
            if (response.length > 0) {
              // view.openPopup({
              //   features: response,
              //   location: event.mapPoint
              // });
            }
            //document.getElementById("viewDiv").style.cursor = "auto";
          }
        }

        view.whenLayerView(TCSALayer).then(function (layerView) {
          // Create a search widget
          var searchWidget = new Search({
            view: view,
            sources: [
              {
                layer: TCSALayer.findSublayerById(0),
                searchFields: ["obieqtis_dasaxeleba"], // Adjust based on your data
                displayField: "obieqtis_dasaxeleba", // Adjust based on your data
                exactMatch: false,
                outFields: ["*"],
                name: "ფენები",
                placeholder: "Search TCSA Layer",
                suggestionsEnabled: true,
              },
            ],
            includeDefaultSources: false, // set to true if you want to include the default sources
            suggestionsEnabled: true,
          });
          searchWidget.on("search-complete", function (event) {
            // handle search results
          });
        });

        var basemapGallery = new BasemapGallery({
          view: view,
          //container: "basemapGalleryDiv",
          source: {
            portal: {
              url: "https://www.arcgis.com",
              useVectorBasemaps: true, // Set to true for vector basemaps
            },
          },
        });
        basemapGalleryRef.current = basemapGallery;

        // // ღილაკზე დაჭერა - toggle
        // document.getElementById("basemapToggleBtn").addEventListener("click", () => {
        //   const galleryDiv = document.getElementById("basemapGalleryDiv");
        //   galleryDiv.style.display = galleryDiv.style.display === "block" ? "none" : "block";
        // });

        // // thumbnail-ის დაყენება პირველ ბეისმეფზე
        // view.when(() => {
        //   const currentBasemap = view.map.basemap;
        //   if (currentBasemap.thumbnailUrl) {
        //     document.getElementById("thumbnailPreview").src = currentBasemap.thumbnailUrl;
        //   }
        // });

        // // thumbnail განახლება ბეისმეფის შეცვლისას
        // reactiveUtils.watch(
        //   () => basemapGallery.activeBasemap,
        //   (newBasemap) => {
        //     if (newBasemap && newBasemap.thumbnailUrl) {
        //       document.getElementById("thumbnailPreview").src = newBasemap.thumbnailUrl;
        //     }
        //   }
        // );

        view.ui.add(measurement, "bottom-right");
        // Set the views for the widgets
        measurement.view = view;

        // Listen for the measurement widget to be fully ready
        view.when(function () {
          measurement.viewModel.newMeasurementActive = true;
          const instructionText = document.querySelector(
            ".esri-area-measurement-2d__hint-text"
          );
          if (instructionText) {
            instructionText.textContent =
              "გთხოვთ დააკლიკოთ რუკაზე რათა დაიწყოთ გაზომვა.";
          }
        });



        const iconImg = document.createElement("img");
        iconImg.style.width = "57px";
        iconImg.style.height = "57px";
        iconImg.style.borderRadius = "4px";
        iconImg.style.marginTop = "1.5px";
        iconImg.style.objectFit = "cover"; // დაამატე ეს, რომ სწორად ჩაჯდეს
        iconImg.src = basemapGallery.activeBasemap.thumbnailUrl; // პირდაპირ დააჭირე აქ thumbnail

        // Custom button container
        const customButton = document.createElement("div");
        customButton.className = "custom-expand-button esri-widget";
        customButton.style.cursor = "pointer";
        // customButton.style.padding = "5px";
        customButton.style.width = "60px";
        customButton.style.height = "60px";
        customButton.style.backgroundColor = "black";
        customButton.appendChild(iconImg);

        const bgExpand = new Expand({
          view: view,
          content: basemapGallery,
          expandIconClass: "my-basemap-icon", // remove default icon
          expandTooltip: t("საბაზისო ფენები"),
          mode: "floating"
        });
        basemapTitleRef.current = bgExpand;

        function updateIconFromBasemap(basemap) {
          const thumbnailUrl = basemap.thumbnailUrl;
          if (thumbnailUrl) {
            iconImg.src = thumbnailUrl;
          }
        }

        // Initial set
        view.when(() => {
          updateIconFromBasemap(basemapGallery.activeBasemap);
        });

        // Update when changed
        basemapGallery.watch("activeBasemap", (newBasemap) => {
          updateIconFromBasemap(newBasemap);
        });

        // // close the expand whenever a basemap is selected
        // basemapGallery.watch("activeBasemap", () => {
        //   const mobileSize =
        //     view.heightBreakpoint === "xsmall" ||
        //     view.widthBreakpoint === "xsmall";

        //   if (mobileSize) {
        //     bgExpand.collapse();
        //   }
        // });

        view.ui.add(bgExpand, "bottom-left");
        function waitForIconNode(attempts = 10) {
          const iconNode = bgExpand.container.querySelector(".my-basemap-icon");

          if (iconNode) {
            console.log("Icon found!", iconNode);
            iconNode.replaceWith(customButton);
            // აქ უკვე შეგიძლია ჩაანაცვლო ან appendChild გააკეთო
            return;
          }

          if (attempts > 0) {
            setTimeout(() => waitForIconNode(attempts - 1), 100);
          } else {
            console.warn("Icon not found after multiple attempts.");
          }
        }
        // მერე დაიწყე ლოდინი
        waitForIconNode();
        //bgExpand._container.querySelector(".esri-expand__icon").replaceWith(customButton);
        // Function to wait for basemaps to load
        function ensureBasemapsLoaded(basemapGallery) {
          return new Promise((resolve) => {
            const checkLoadedStatus = () => {
              // Check if all basemaps are loaded
              const allLoaded = basemapGallery.source.basemaps.every(
                (basemap) => basemap.loaded
              );

              if (allLoaded) {
                resolve();
              } else {
                // Check again in a short timeout
                setTimeout(checkLoadedStatus, 100);
              }
            };

            // Start checking
            checkLoadedStatus();
          });
        }

        const updateBasemapTitles = (basemapGallery) => {
          if (!basemapGallery?.source?.basemaps) return;
          // Iterate over basemaps and update titles
          basemapGallery.source.basemaps.forEach(function (basemap) {
            if (basemap.loaded) {
              if (basemap.title === "Topographic") {
                basemap.title = t("ტოპოგრაფიული"); // Your translation
              } else if (basemap.title === "Streets") {
                basemap.title = t("ქუჩები"); // Your translation
              } else if (basemap.title === "Imagery") {
                basemap.title = t("სატელიტური")
              }
              else if (basemap.title === "Imagery Hybrid") {
                basemap.title = t("სატელიტურ ჰიბრიდული"); // Your translation
              } else if (basemap.title === "Navigation") {
                basemap.title = t("ნავიგაციური"); // Your translation
              } else if (basemap.title === "Navigation (Dark)") {
                basemap.title = t("ნავიგაციური ბნელი"); // Your translation
              } else if (basemap.title === "Newspaper Map") {
                basemap.title = t("გაზეთის რუკა"); // Your translation
              } else if (basemap.title === "Community Map") {
                basemap.title = t("საზოგადოებრივი"); // Your translation
              } else if (basemap.title === "Streets (Night)") {
                basemap.title = t("ქუჩების (ღამე)"); // Your translation
              } else if (basemap.title === "Terrain with Labels") {
                basemap.title = t("ფიზიკურ ტვისობრივი ეტიკეტები"); // Your translation
              } else if (basemap.title === "Light Gray Canvas") {
                basemap.title = t("ღია ნაცრისფერი ტილო"); // Your translation
              } else if (basemap.title === "Dark Gray Canvas") {
                basemap.title = t("მუქი ნაცრისფერი ტილო"); // Your translation
              } else if (basemap.title === "Outdoor") {
                basemap.title = t("გარე სივრცის"); // Your translation
              } else if (basemap.title === "Oceans") {
                basemap.title = t("ოკეანეების"); // Your translation
              } else if (basemap.title === "National Geographic Style Map") {
                basemap.title = t("ნაციონალური გეოგრაფიული რუკა"); // Your translation
              } else if (basemap.title === "OpenStreetMap") {
                basemap.title = t("ღია ქუჩების რუკა"); // Your translation
              } else if (basemap.title === "Charted Territory Map") {
                basemap.title = t("კარტირებული ტერიტორიების რუკა"); // Your translation
              } else if (basemap.title === "Human Geography Map") {
                basemap.title = t("საზოგადოებრივ გეოგრაფიული რუკა"); // Your translation
              } else if (basemap.title === "Human Geography Dark Map") {
                basemap.title = t("საზოგადოებრივ გეოგრაფიული მუქი რუკა"); // Your translation
              } else if (basemap.title === "Modern Antique Map") {
                basemap.title = t("თანამედროვე ანტიკური რუკა"); // Your translation
              } else if (basemap.title === "Mid-Century Map") {
                basemap.title = t("შუასაუკუნეების რუკა"); // Your translation
              } else if (basemap.title === "Nova Map") {
                basemap.title = t("ნოვას რუკა"); // Your translation
              } else if (basemap.title === "Colored Pencil Map") {
                basemap.title = t("ფერადი ფანქრის რუკა"); // Your translation
              } else if (basemap.title === "Firefly Imagery Hybrid") {
                basemap.title = t("მანათობელი სატელიტური რუკა"); // Your translation
              } else if (basemap.title === "Blueprint") {
                basemap.title = t("გეგმური"); // Your translation
              } else if (basemap.title === "Enhanced Contrast Map") {
                basemap.title = t("გაძლიერებული კონტრასტული რუკა"); // Your translation
              } else if (basemap.title === "Enhanced Contrast Dark Map") {
                basemap.title = t("გაძლიერებულ კონტრასტული მუქი რუკა"); // Your translation
              } else if (basemap.title === "Topographic (Vector)") {
                basemap.title = t("ტოპოგრაფიული რუკა (ვექტორული)"); // Your translation
              } else if (basemap.title === "Environment Map") {
                basemap.title = t("ეკოლოგიური რუკა"); // Your translation
              } else if (basemap.title === "Navigation (Places)") {
                basemap.title = t("ნავიგაცია (ადგილები)"); // Your translation
              } else if (basemap.title === "Navigation (Dark - Places)") {
                basemap.title = t("ნავიგაცია (მუქი თემა – ადგილები)"); // Your translation
              }
            }
          });


          setTimeout(() => {
            document.querySelectorAll(".esri-basemap-gallery__item").forEach(item => {
              const labelSpan = item.querySelector(".esri-basemap-gallery__item-title span");
              if (!labelSpan) return;

              const titleText = labelSpan.textContent;

              if (titleText === "სატელიტური") {
                item.title = t("ეს რუკა მოიცავს დეტალურ საცნობარო შრეს მსოფლიოსთვის, რომელიც დაფენილია სატელიტურ გამოსახულებაზე.");
              }

              if (titleText === "სატელიტურ ჰიბრიდული") {
                item.title = t("ეს რუკა მსოფლიოს სატელიტურ გამოსახულებას და მრავალი ტერიტორიის მაღალი გარჩევადობის აეროგამოსახულებას მოიცავს.");
              }

              if (titleText === "ქუჩები") {
                item.title = t("ეს რუკა მსოფლიოსთვის მაგისტრალებისა და ქუჩების დეტალურ მონაცემებს ასახავს.");
              }

              if (titleText === "ტოპოგრაფიული") {
                item.title = t("ეს ტოპოგრაფიული რუკა განკუთვნილია, როგორც საბაზო რუკა და საცნობარო რუკა. რუკა შედგენილია Esri-ის და ArcGIS მომხმარებელთა საზოგადოების მიერ, საუკეთესო ხელმისაწვდომი წყაროებიდან.");
              }

              if (titleText === "ნავიგაციური") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას მორგებული სანავიგაციო რუკის სტილით.");
              }

              if (titleText === "ნავიგაციური ბნელი") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას მორგებული ღამის ქუჩის რუკის სტილით.");
              }

              if (titleText === "გაზეთის რუკა") {
                item.title = t("ეს რუკა ასახავს დაჩრდილული რელიეფის გამოსახულებას, ბათიმეტრიას და სანაპირო წყლის მახასიათებლებს, რომლებიც უზრუნველყოფენ ნეიტრალურ ფონს პოლიტიკური საზღვრებითა და ადგილების სახელებით საცნობარო მიზნებისთვის.");
              }

              if (titleText === "საზოგადოებრივი") {
                item.title = t("ეს რუკა შექმნილია იმისთვის, რომ თქვენი თემატური შინაარსისკენ მიაპყროს ყურადღება ნეიტრალური ფონის უზრუნველყოფით, მინიმალური ფერებით, ეტიკეტებითა და მახასიათებლებით.");
              }

              if (titleText === "ქუჩების (ღამე)") {
                item.title = t("ეს ვებ რუკა გთავაზობთ დეტალურ საბაზო რუკას ბუნებრივ სამყაროზე აქცენტით. ის მოიცავს მდიდარ კარტოგრაფიულ სტილს ვექტორული კონტურებითა და ვექტორული ბორცვების დაჩრდილვით (hillshade). ეს არის მრავალწყაროიანი სტილი.");
              }

              if (titleText === "ფიზიკურ ტვისობრივი ეტიკეტები") {
                item.title = t("ეს რუკა შექმნილია, როგორც საბაზო რუკა საზღვაო GIS პროფესიონალებისთვის და როგორც საცნობარო რუკა ყველასთვის, ვინც ოკეანის მონაცემებით არის დაინტერესებული.");
              }

              if (titleText === "ღია ნაცრისფერი ტილო") {
                item.title = t("ეს ვექტორული ვებ რუკა გთავაზობთ მსოფლიოს დეტალურ ხედს ლამაზი პოლიტიკური საზღვრებით, წარწერებითა და ფონით, რომელიც ხაზს უსვამს მიწის ფიზიკური მახასიათებლების განსხვავებებს.");
              }

              if (titleText === "მუქი ნაცრისფერი ტილო") {
                item.title = t("OpenStreetMap (OSM) არის ერთობლივი პროექტი, რომელიც მიზნად ისახავს მსოფლიოს თავისუფალი, რედაქტირებადი რუკის შექმნას. ეს ვექტორული საბაზო რუკა დაფუძნებულია OSM მონაცემთა Daylight რუკის დისტრიბუციაზე და მასპინძლობს Esri. ვექტორული შრე წარმოდგენილია OSM კარტოგრაფიით.");
              }

              if (titleText === "გარე სივრცის") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ ფილების (tile) საბაზო რუკას გეოპოლიტიკური სტილით, რომელიც ბეჭდური ატლასის ფურცელს ან სასკოლო საკლასო ოთახის კედლის რუკას მოგაგონებთ.");
              }

              if (titleText === "ოკეანეების") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ ფილების (tile) საბაზო რუკას სტილით, რომელიც ოპტიმიზებულია სპეციალური ინტერესის ზონების (AOIs) საჩვენებლად, რომლებიც შექმნილი და რედაქტირებულია Community Maps-ის კონტრიბუტორების მიერ.");
              }

              if (titleText === "ნაციონალური გეოგრაფიული რუკა") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას მორგებული მუქი რეჟიმის სანავიგაციო რუკის სტილით.");
              }

              if (titleText === "ღია ქუჩების რუკა") {
                item.title = t("ეს რუკა არის შავ-თეთრი დიზაინი ნახევარტონური შაბლონებით (halftone patterns), წითელი აქცენტებით და სტილიზებული შრიფტებით.");
              }

              if (titleText === "კარტირებული ტერიტორიების რუკა") {
                item.title = t("ეს რუკა შედგება ვექტორული ფილების შრეებისგან, რომლებიც მსოფლიოს დეტალურ საბაზო რუკას ქმნიან, მუქი მონოქრომატული სტილით და შინაარსით, რომელიც მორგებულია ადამიანის გეოგრაფიის ინფორმაციის მხარდასაჭერად.");
              }

              if (titleText === "საზოგადოებრივ გეოგრაფიული რუკა") {
                item.title = t("რუკის უნიკალური მორგება. მე-18 და მე-19 საუკუნეების ანტიკური რუკების იერსახის განახლება მულტი-მასშტაბიანი რუკების თანამედროვე სამყაროში.");
              }

              if (titleText === "საზოგადოებრივ გეოგრაფიული მუქი რუკა") {
                item.title = t("ეს მორგებული რუკა, 1950-იანი წლების ხელოვნებისა და რეკლამის შთაგონებით, წარმოადგენს უნიკალურ დიზაინის ვარიანტს ArcGIS-ის საბაზო რუკებისთვის.");
              }

              if (titleText === "თანამედროვე ანტიკური რუკა") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ ფილების (tile) საბაზო რუკას მუქი ფონით და მოციმციმე ლურჯი სიმბოლოებით, რაც ArcGIS.com-ის მისასალმებელი ეკრანით (splash screen) არის შთაგონებული.");
              }

              if (titleText === "შუასაუკუნეების რუკა") {
                item.title = t("ეს ვებ რუკა გთავაზობთ მსოფლიოს დეტალურ საბაზო რუკას ხელნაკეთი იერით, თითქოს ფერადი ფანქრებით იყოს შექმნილი.");
              }

              if (titleText === "ნოვას რუკა") {
                item.title = t("ეს რუკა დაფუძნებულია OSM მონაცემთა Daylight რუკის დისტრიბუციაზე და მასპინძლობს Esri. რუკა წარმოდგენილია კრეატიული კარტოგრაფიული სტილით, რომელიც ასახავს ტექნიკური ნახაზის (blueprint) იერსახეს.");
              }

              if (titleText === "ფერადი ფანქრის რუკა") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ საბაზო რუკას კლასიკური Esri ტოპოგრაფიული რუკის სტილით, ვექტორული კონტურებითა და ბორცვების დაჩრდილვის (hillshade) შრეებით. ეს არის მრავალწყაროიანი სტილი.");
              }

              if (titleText === "მანათობელი სატელიტური რუკა") {
                item.title = t("მსოფლიოს დეტალური რუკა, რომელიც გამოირჩევა ნეიტრალური სტილით და შინაარსით, რომელიც მორგებულია გარემოს, ლანდშაფტის, ბუნებრივი რესურსების, ჰიდროლოგიური და ფიზიკური გეოგრაფიის შრეების მხარდასაჭერად.");
              }

              if (titleText === "გეგმური") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ საბაზო რუკას გაძლიერებული კონტრასტით, რომელიც მიზნად ისახავს WCAG-ისა და აშშ-ის მთავრობის 508-ე სექციის სტანდარტებთან შესაბამისობას. რუკის დეტალები აგებულია უფრო მაღალი კონტრასტით და ფერთა მხედველობის დეფიციტისთვის უსაფრთხო ფერებით.");
              }

              if (titleText === "გაძლიერებული კონტრასტული რუკა") {
                item.title = t("ეს რუკა გთავაზობთ მსოფლიოს დეტალურ ვექტორულ საბაზო რუკას მუქი ფერებითა და გაძლიერებული კონტრასტით, რომელიც მიზნად ისახავს WCAG-ისა და აშშ-ის მთავრობის 508-ე სექციის სტანდარტებთან შესაბამისობას. რუკის დეტალები აგებულია უფრო მაღალი კონტრასტით და ფერთა მხედველობის დეფიციტისთვის უსაფრთხო ფერებით.");
              }

              if (titleText === "გაძლიერებულ კონტრასტული მუქი რუკა") {
                item.title = t("ეს რუკა წარმოადგენს სანავიგაციო საბაზო რუკის მორგებულ ვერსიას დეტალური ადგილებით, ანუ ინტერესის წერტილებით.");
              }

              if (titleText === "ტოპოგრაფიული რუკა (ვექტორული") {
                item.title = t("ეს რუკა წარმოადგენს სანავიგაციო მუქი საბაზო რუკის მორგებულ ვერსიას დეტალური ადგილებით, ანუ ინტერესის წერტილებით.");
              }


            });
          }, 1000); // საჭიროა ცოტა დაგვიანება, სანამ ვიჯეტი სრულად დაიხატება

          // Re-render the gallery to update the UI
          basemapGallery.render();
        }
        // Watch for changes in basemap length and update titles
        basemapGallery.watch("source.basemaps.length", async function () {
          // Wait for all basemaps to load
          await ensureBasemapsLoaded(basemapGallery);
          updateBasemapTitles(basemapGallery)

        });
        // Call the appropriate DistanceMeasurement2D or DirectLineMeasurement3D
        function distanceMeasurement() {
          const type = activeView.type;
          measurement.activeTool =
            type.toUpperCase() === "2D" ? "distance" : "direct-line";
          distanceButton.classList.add("active");
          areaButton.classList.remove("active");
        }

        // Call the appropriate AreaMeasurement2D or AreaMeasurement3D
        function areaMeasurement() {
          measurement.activeTool = "area";
          distanceButton.classList.remove("active");
          areaButton.classList.add("active");
        }

        // Clears all measurements
        function clearMeasurements() {
          distanceButton.classList.remove("active");
          areaButton.classList.remove("active");
          measurement.clear();
        }
        // Call doQuery() each time the button is clicked
        view.when(() => {
          document
            .getElementById("searchButton")
            .addEventListener("click", doQuery);
          definitionQueryFromObjectRegistry(); //ობიექტის რეესტრიდან როცა გადმოვდივართ დაფილიტროს კონკრეტული ობიექტი
        });

        // Function to merge extents
        function mergeExtents(extent1, extent2) {
          if (!extent1) return extent2;
          if (!extent2) return extent1;
          return extent1.union(extent2);
        }
        // Function to zoom to the combined extent
        function zoomToCombinedExtent(view) {
          if (combinedExtent) {
            view.goTo(combinedExtent).catch(function (error) {
              console.error("Error zooming to extent: ", error);
            });
          }
        }

        //ფუნქცია საიმისოდ რომ წერტილის და პოლიგონის შემთხვევაში სხვადასხვანაირად დავაბრუნოთ ექსტენტი
        function getExtentFromFeature(feature, view) {
          const geometry = feature.geometry;
          const spatialReference = view.spatialReference;
          if (geometry.type === "point") {
            const buffer = 0.01; // Adjust as needed for zoom scale.
            return new Extent({
              xmin: geometry.x - buffer,
              ymin: geometry.y - buffer,
              xmax: geometry.x + buffer,
              ymax: geometry.y + buffer,
              spatialReference: geometry.spatialReference
            });
          } else if (geometry.extent) {
            return geometry.extent;
          } else {
            console.warn("Feature does not have a valid geometry.");
            return null;
          }
        }

        var combinedExtent = null;
        async function definitionQueryFromObjectRegistry() {
          let caseNumberList = sessionStorage.getItem("caseNumberList");

          // Show loader
          document.getElementById("loader").style.display = "block";

          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          if (!caseNumberList || caseNumberList === "") {
            if (urlParams != "") {
              let anyFeatureFound = false;
              await Promise.all(
                TCSALayer.sublayers.map(async (sublayer) => {
                  if (sublayer.sublayers) {
                    await Promise.all(
                      sublayer.sublayers.map(async (subsublayer) => {
                        await searchSublayers(subsublayer, sublayer);
                      })
                    );
                  }
                  await searchSublayers(sublayer);
                })
              );

              if (!anyFeatureFound) {
                setShowMapPopup(true);
              }

              async function searchSublayers(layerSublayer, isSubSublayer) {

                const objectid = urlParams.get("id");
                const caseNumber = await getCaseNumberByID(objectid);
                if (!caseNumber) {
                  return;
                }

                let query = layerSublayer.createQuery();
                const featureLayerTEST = new FeatureLayer({
                  url: layerSublayer.url,
                });
                let expression =
                  "gancxadebis_nomeri LIKE '%" + caseNumber + "%'";
                query.where = expression;
                query.outFields = ["*"];
                featureLayerTEST.definitionExpression = expression;
                layerSublayer.definitionExpression = expression;

                try {
                  const response = await featureLayerTEST.queryFeatures(query);
                  if (response.features.length > 0) {
                    anyFeatureFound = true;
                    //layerSublayer.visible = true;
                    if (isSubSublayer) {

                      //isSubSublayer.visible = true;

                      for (const layerYT of parentGroupLayer.layers.items) {
                        if (layerYT.title === isSubSublayer.title) {
                          layerYT.visible = true; // Found the layer
                        }

                      }
                    }
                    else {
                      for (const layerYT of parentGroupLayer.layers.items) {
                        if (layerYT.title === layerSublayer.title) {
                          layerYT.visible = true; // Found the layer
                        }

                      }
                    }
                    const featureExtent = getExtentFromFeature(response.features[0], view);
                    if (featureExtent) {
                      combinedExtent = mergeExtents(combinedExtent, featureExtent);
                    }
                    // combinedExtent = mergeExtents(
                    //   combinedExtent,
                    //   response.features[0].geometry.extent
                    // );
                    zoomToCombinedExtent(view);
                  }
                } catch (error) {
                  // Handle errors
                }
                setLoading(false);
              }
            }
          } else {
            sessionStorage.setItem("caseNumberList", ""); // Clear the session storage list

            await Promise.all(
              TCSALayer.sublayers.map(async (sublayer) => {
                if (sublayer.sublayers) {
                  await Promise.all(
                    sublayer.sublayers.map(async (subsublayer) => {
                      await searchSublayers(subsublayer, sublayer);
                    })
                  );
                  setLoading(false);
                }
                await searchSublayers(sublayer);
              })
            );


            async function searchSublayers(layerSublayer, isSubSublayer) {
              let query = layerSublayer.createQuery();
              const featureLayerTEST = new FeatureLayer({
                url: layerSublayer.url,
              });
              let expression = "gancxadebis_nomeri in (" + caseNumberList + ")";
              query.where = expression;
              query.outFields = ["*"];
              featureLayerTEST.definitionExpression = expression;
              layerSublayer.definitionExpression = expression;

              try {
                const response = await featureLayerTEST.queryFeatures(query);
                if (response.features.length > 0) {
                  layerSublayer.visible = true;
                  if (isSubSublayer) {
                    isSubSublayer.visible = true;
                  }
                  combinedExtent = mergeExtents(
                    combinedExtent,
                    response.features[0].geometry.extent
                  );
                  zoomToCombinedExtent(view);
                }
                setLoading(false);
              } catch (error) {
                // Handle errors
              }
            }
          }
          // Hide loader after all async operations are complete
          document.getElementById("loader").style.display = "none";
        }

        // ვაწვდით პარამეტრად id-ს და აბრუნებს casenumber -ს
        async function getCaseNumberByID(id) {
          try {
            const params = {
              Id: id,
            };
            const response = await axios.get(`${baseURL}/GetCaseByIdByuser`, {
              params,
            });
            return response.data.data.caseNumber;
          } catch (error) { }
        }
        function doQuery() {
          var expression =
            "Obieqtis_Dasaxeleba like N'%" +
            document.getElementById("searchText").value +
            "%' or Obieqtis_Mflobeli like N'%" +
            document.getElementById("searchText").value +
            "%'";
          TCSALayer.findSublayerById(9).definitionExpression = expression;
          // }
        }

        // Create your custom HTML element
        var searchContainerElement = document.getElementById("search-container");

        // Add the custom element to the bottom-right of the map view
        view.ui.add(searchContainerElement, "top-left");

        // view.ui.add(layerList, 'bottom-right');
        var printWidget = new Print({
          view: view,
          printServiceUrl:
            "https://gis.economy.ge/server/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task",
          placement: "top-left",
        });

        // Create your custom HTML element
        var printExpanddiv = document.getElementById("printExpandDiv");
        var printExpand = new Expand({
          expandIconClass: "esri-icon-printer",
          expandTooltip: t("ამოპრინტვა"),
          view: view,
          content: printWidget,
          container: printExpanddiv,
        });

        printExpanddiv.addEventListener("click", () => {
          // თარგმნა
          const observer = new MutationObserver(function (
            mutationsList,
            observer
          ) {
            const instructionText = document.querySelector(
              ".esri-print__header-title"
            );
            if (instructionText) {
              instructionText.textContent = "ექსპორტი";
              //observer.disconnect();  // Stop observing after the text is modified
            }
            // Get all containers with the same class
            const containers = document.querySelectorAll(
              ".esri-print__form-section-container"
            );
            containers.forEach((container) => { });
            containers.forEach((container) => {
              const label = container.querySelector("label");

              if (label) {
                const input = label.querySelector("input");
                if (input) {
                  // Check for specific content to differentiate containers
                  if (label.textContent.includes("Title")) {
                    // Update label and placeholder for the title input
                    label.firstChild.textContent = "სათაური";
                    input.setAttribute("placeholder", "ფაილის სახელი");
                  }
                  // Add more conditions if you have more containers to update
                } else {
                  if (label.textContent.includes("Page setup")) {
                    // Update label and placeholder for the page setup input
                    label.firstChild.textContent = "გვერდის პარამეტრები"; // Example translation
                  } else if (label.textContent.includes("File format")) {
                    // Update label and placeholder for the page setup input
                    label.firstChild.textContent = "ფაილის ფორმატი"; // Example translation
                  }
                }
              }
            });

            // Translate the Export button
            const exportButton = document.querySelector(
              ".esri-print__export-button"
            ); // Update with the actual class or ID
            if (exportButton) {
              exportButton.textContent = "ექსპორტი"; // Update to the desired translation
            }

            // Translate the Layout and Map Only tabs
            const layoutTab = document.querySelector(
              '[data-tab-id="layoutTab"]'
            );
            if (layoutTab) {
              layoutTab.textContent = "განლაგება"; // Update to the desired translation
            }

            const mapOnlyTab = document.querySelector(
              '[data-tab-id="mapOnlyTab"]'
            );
            if (mapOnlyTab) {
              mapOnlyTab.textContent = "მხოლოდ რუკა"; // Update to the desired translation
            }

            // Translate the Advanced Options text
            const advancedOptionsText = document.querySelector(
              ".esri-print__advanced-options-button-title"
            );
            if (advancedOptionsText) {
              advancedOptionsText.textContent = "დამატებითი პარამეტრები"; // Update to the desired translation
            }
            observer.disconnect();

            // Translate the Exported Files heading
            const exportedFilesTitle = document.querySelector(
              ".esri-print__export-title"
            );
            if (exportedFilesTitle) {
              exportedFilesTitle.textContent = "ექსპორტირებული ფაილები"; // Update to the desired translation
            }

            // Translate the "Your exported files will appear here." text
            const exportedFilesMessage = document.querySelector(
              ".esri-print__export-message"
            );
            if (
              exportedFilesMessage &&
              exportedFilesMessage.textContent.includes(
                "Your exported files will appear here."
              )
            ) {
              exportedFilesMessage.textContent =
                "თქვენი ექსპორტირებული ფაილები აქ გამოჩნდება."; // Update to the desired translation
            }
          });

          // Start observing the measurement widget's container for child elements
          observer.observe(printExpand.domNode, {
            childList: true,
            subtree: true,
          });
        });

        // Create the Legend widget
        const legend = new Legend({
          view: view
        });

        // Create Expand widget for the Legend
        const legendExpand = new Expand({
          view: view,
          content: legend, // Attach the Legend widget
          expandIconClass: "esri-icon-layer-list", // Choose a suitable icon
          expandTooltip: t("რუკის ლეგენდის ნახვა"),
          expanded: false // Start collapsed
        });
        //ალეკს
        legendExpandRef.current = legendExpand;
        // Place the Expand widget inside the toolsPanel
        view.ui.add(legendExpand, "manual"); // Prevent it from auto-adding to the view
        document.getElementById("legendExpandDiv").appendChild(legendExpand.domNode);
        // legendExpand.watch("expanded", function (isExpanded) {
        //   if (window.innerWidth < 768) {
        //     const printExpandDiv = document.querySelector("#printExpandDiv");

        //     if (isExpanded) {
        //         // Show the div when expanded
        //         printExpandDiv.style.display = "none";
        //     } else {
        //         // Hide the div when collapsed
        //         printExpandDiv.style.display = "block";
        //     }
        //   }
        // });

        const observerLegendMessage = new MutationObserver(() => {
          const noLegendElement = document.querySelector(".esri-legend__message");
          if (noLegendElement) {
            noLegendElement.innerText = "ლეგენდა ცარიელია";
            observerLegendMessage.disconnect(); // Stop observing after changing text
          }
        });

        observerLegendMessage.observe(document.body, { childList: true, subtree: true });

        legend.watch("activeLayerInfos.length", (length) => {
          if (length === 0) {
            observerLegendMessage.observe(document.body, { childList: true, subtree: true });
          }
        });


        const suggestionsDiv = document.getElementById("suggestions");

        reactiveUtils.when(
          () => view?.stationary === true,
          async () => {
            if (view.extent) {
              updateSuggestions();
            }
          }
        );

        searchText.addEventListener("input", updateSuggestions);
        searchText.addEventListener("click", function (event) {
          if (searchText.value != "")
            suggestionsDiv.style = "visibility:visible";
        });

        function updateSuggestions() {
          //var suggestionsFound = false;
          if (searchText.value == "") {
            suggestionsDiv.innerHTML = ""; // Clear existing suggestions
            suggestionsDiv.style = "visibility:hidden";
          } else {
          }
        }



        // Function to update the text
        function updatePopupButtonText() {
          document
            .querySelectorAll(".esri-popup__action-text")
            .forEach(function (element) {
              if (element.innerText === "Zoom to") {
                element.innerText = "დაზუმება";
              } else if (element.innerText === "Browse features") {
                element.innerText = "დათვალიერება";
              }
            });
        }

        // Set up a MutationObserver to watch for changes in the popup
        const observer = new MutationObserver(updatePopupButtonText);

        // Start observing the popup content for changes
        view.popup.watch("visible", function (visible) {
          if (visible) {
            // Wait for the popup to render
            setTimeout(function () {
              updatePopupButtonText();

              // Observe the popup for content changes
              const popupContent = document.querySelector(
                ".esri-popup__main-container"
              );
              if (popupContent) {
                observer.observe(popupContent, {
                  childList: true,
                  subtree: true,
                });
              }
            }, 100);
          } else {
            // Disconnect the observer when the popup is closed
            observer.disconnect();
          }
        });

        //const basemapGalleryDiv = document.querySelector('.esri-basemap-gallery');
        if (window.innerWidth > 768) {
          const collapsedSearchBar = document.querySelector(".esri-ui-top-left");
          collapsedSearchBar.style.marginLeft = "340px";
          const collapsedExpand = document.querySelector(".esri-ui-bottom-left");
          collapsedExpand.style.marginLeft = "340px";
        }

        // Apply grid layout when the widget is expanded or view is resized
        function applyGridLayout() {
          var basemapGalleryDiv = document.querySelector('.esri-widget--panel-height-only');

          // Check if the div exists and the window is wide enough
          if (basemapGalleryDiv && window.innerWidth <= 768) {
            // if (!basemapGalleryDiv.classList.contains('esri-basemap-gallery--grid')) {
            //   basemapGalleryDiv.classList.add('esri-basemap-gallery--grid');
            // }
          }
        }

        // Initial check when the page loads
        applyGridLayout();

        // Apply grid layout when the BasemapGallery is expanded
        bgExpand.watch('expanded', (isExpanded) => {
          if (isExpanded) {
            applyGridLayout(); // Apply the grid layout when expanded
          }
        })

        // Toggle sidebar
        const toggleSidebar = () => {
          const sidebar = document.getElementById("layerListPanel");
          const toggleButton = document.getElementById("toggleSidebarBtn");
          const collapsedSearchBar =
            document.querySelector(".esri-ui-top-left");
          const collapsedExpand = document.querySelector(
            ".esri-ui-bottom-left"
          );

          sidebar.classList.toggle("collapsed");
          if (window.innerWidth > 768) {
            if (sidebar.classList.contains("collapsed")) {
              collapsedSearchBar.style.marginLeft = "0px";
              collapsedExpand.style.marginLeft = "0px";
              setFenebisbar(true);
              toggleButton.innerHTML = "&gt;"; // Show >
              toggleButton.style.left = "0px"; // Move button to the left side
            } else {
              setFenebisbar(false);
              collapsedSearchBar.style.marginLeft = "340px";
              collapsedExpand.style.marginLeft = "340px";
              toggleButton.innerHTML = "&lt;"; // Show <
              toggleButton.style.left = "320px"; // Position it near the right edge of the panel
            }
          }
          else {

            if (sidebar.classList.contains("collapsed")) {

              setFenebisbar(true);
              toggleButton.innerHTML = "&gt;"; // Show >

            } else {
              setFenebisbar(false);

              toggleButton.innerHTML = "&lt;"; // Show <

            }

            const InteractiveMappanel = document.getElementById('InteractiveMap'); // Assuming this is your panel's ID
            InteractiveMappanel.classList.add('InteractiveMap_blur-active');

            if (sidebar.classList.contains('collapsed')) {
              InteractiveMappanel.classList.remove('InteractiveMap_blur-active');
            } else {
              InteractiveMappanel.classList.add('InteractiveMap_blur-active');
            }
          }
        };

        Explanation: document
          .getElementById("toggleSidebarBtn")
          .addEventListener("click", toggleSidebar);

        // Tools Panel Toggle
        const toolsToggleBtn = document.getElementById("toolsToggleBtn");
        const toolsPanel = document.getElementById("toolsPanel");

        toolsToggleBtn.addEventListener("click", () => {
          toolsPanel.classList.toggle("show");
        });


        /*popuptemplate logic */
        // Reference to the custom popup container
        const customPopup = document.getElementById("customPopup");

        // Variable to track the currently displayed layer
        const mapContainer = document.getElementById("InteractiveMap"); // Assuming your map container has this ID

        function adjustPopupPosition(screenPoint) {
          // Get the map container dimensions
          const mapBounds = view.container.getBoundingClientRect();
          const popupWidth = customPopup.offsetWidth;
          const popupHeight = customPopup.offsetHeight;

          // Calculate initial popup position
          let left = screenPoint.x - popupWidth / 2;
          let top = screenPoint.y - popupHeight - 10; // Place above the clicked point with a gap

          // Adjust if popup overflows horizontally
          if (left < 0) {
            left = 10; // Adjust to the right if it overflows on the left
          } else if (left + popupWidth > mapBounds.width) {
            left = mapBounds.width - popupWidth - 10; // Adjust to the left if it overflows on the right
          }

          // Adjust if popup overflows vertically
          if (top < 0) {
            top = screenPoint.y + 10; // Move below the clicked point if it overflows at the top
          } else if (top + popupHeight > mapBounds.height) {
            top = mapBounds.height - popupHeight - 10; // Adjust upward if it overflows at the bottom
          }

          // Apply calculated position
          customPopup.style.left = `${left}px`;
          customPopup.style.top = `${top}px`;
        }






        let currentLayerTitle = "";
        view.on("click", async (event) => {
          if (popupsEnabled) {
            const response = await view.hitTest(event);
            //!firstLayer.graphic.layer.title.includes("ძველი")
            // Check if the clicked feature is a cluster
            const cluster = response.results.find(result => result.graphic && result.graphic.attributes && result.graphic.attributes.cluster_count);

            // If it's a cluster, do nothing and return
            if (cluster) {
              console.log("Click is inside a cluster, no features to display.");
              customPopup.style.display = "none"; // Hide the popup
              return; // Exit early
            }
            // Get the features at the click location, but exclude basemap layers
            const features = response.results.filter(result =>
              result.graphic.layer && !isBasemapLayer(result.graphic.layer) && !cluster
            );
            // Filter out duplicates by layer title
            const uniqueLayers = {};
            features.forEach(result => {
              const layerTitle = result.graphic.layer.title;
              if (!uniqueLayers[layerTitle]) {
                uniqueLayers[layerTitle] = result;
              }
            });

            // If there are no features, hide the popup
            if (Object.keys(uniqueLayers).length === 0) {
              customPopup.style.display = "none";
              currentLayerTitle = ""; // Reset the current layer title when no features are found
              return;
            }

            const screenPoint = view.toScreen(event.mapPoint);
            // Show the popup
            customPopup.style.display = "block";
            adjustPopupPosition(screenPoint);

            // customPopup.style.left = `${screenPoint.x}px`;
            // customPopup.style.top = `${screenPoint.y}px`;
            // customPopup.style.left = event.x + "px";
            // customPopup.style.top = event.y + "px";

            // Adjust popup position dynamically
            const popupWidth = customPopup.offsetWidth;
            const popupHeight = customPopup.offsetHeight;

            // // Prevent overflow on the right
            // if (event.x + popupWidth > window.innerWidth) {
            //   customPopup.style.left = window.innerWidth - popupWidth - 10 + "px"; // 10px padding from the edge
            // } else {
            //   customPopup.style.left = event.x + "px";
            // }

            // // Prevent overflow at the bottom
            // if (event.y + popupHeight > window.innerHeight) {
            //   customPopup.style.top = window.innerHeight - popupHeight - 10 + "px"; // 10px padding from the edge
            // } else {
            //   customPopup.style.top = event.y + "px";
            // }

            // Initialize the popup content
            let popupContent = "<div>";

            // Add the links for each unique layer
            if (Object.keys(uniqueLayers).length > 1) {
              Object.values(uniqueLayers).forEach(result => {
                popupContent += `
              <div><a href="#" onclick="showDetails('${result.graphic.layer.title}')">${result.graphic.layer.title}</a></div>
            `;
              });
            }
            // Default to showing the first unique layer's details
            const firstLayer = Object.values(uniqueLayers)[0];

            // Find the popup configuration for the layer
            const firstLayerConfig = popupConfigsArray.find(config => config.attributes.LayerName === firstLayer.graphic.layer.title);
            //ძველი ფუნქცია რომელიც მუშაობდა ნელა ძალიან
            // if (firstLayer.graphic.layer.title.includes("ძველი")) {
            //   if (!firstLayerConfig) {
            //     customPopup.innerHTML = `<div> ${firstLayer.graphic.layer.title}</div>`;
            //     return;
            //   }

            //   const selectedFeature = firstLayer.graphic;
            //   const layer = selectedFeature.layer;

            //   const query = layer.createQuery();
            //   //query.where = `OBJECTID = ${selectedFeature.attributes.OBJECTID}`; // Assuming OBJECTID is available
            //   const queryString = window.location.search;
            //   const urlParams = new URLSearchParams(queryString);
            //   if (urlParams.get("id"))
            //     query.where = `gancxadebis_nomeri like '${urlParams.get("id")}%'`;
            //   else
            //     query.where = `OBJECTID = ${selectedFeature.attributes.OBJECTID}`;
            //     //query.where = "";
            //   query.outFields = ["*"];  // Request all fields

            //   // Perform the query to get all attributes
            //   const queryResponse = await layer.queryFeatures(query);


            //   // Ensure we have features in the response
            //   if (queryResponse.features.length >= 0) {
            //     const attributes = queryResponse.features[0].attributes;

            //     // Filter attributes based on PopupFields from the configuration
            //     const popupFields = firstLayerConfig.attributes.PopupFields.split(',').map(field => field.trim());

            //     // Filter the attributes to only include those listed in PopupFields
            //     const filteredAttributes = {};
            //     popupFields.forEach(field => {
            //       // Split the field by ' - ' to get the field name and alias
            //       const [fieldName, alias] = field.split(" - ").map(part => part.trim());

            //       // Check if the fieldName exists in the attributes
            //       if (attributes.hasOwnProperty(fieldName)) {
            //         // Store the field value along with the alias
            //         filteredAttributes[alias] = attributes[fieldName];
            //       }
            //     });

            //     //   // Generate the table based on filtered attributes
            //     //   customPopup.innerHTML = `
            //     //   <div>
            //     //     <h3>${firstLayer.graphic.layer.title}</h3>
            //     //     ${generateTable(filteredAttributes)}  <!-- Pass the filtered attributes here -->
            //     //     <hr>
            //     //     ${popupContent}
            //     //   </div>
            //     // `;
            //     customPopup.innerHTML = `
            //     <div>
            //       <h3>${firstLayer.graphic.layer.title}</h3>
            //       ${generateTable(filteredAttributes)}
            //       <hr>
            //       ${popupContent}
            //     </div>
            //   `;
            //     // Optional: Add drag functionality
            //     let isDragging = false;

            //     customPopup.addEventListener("mousedown", (e) => {
            //       isDragging = true;
            //       let startX = e.clientX - customPopup.offsetLeft;
            //       let startY = e.clientY - customPopup.offsetTop;

            //       const onMouseMove = (e) => {
            //         if (isDragging) {
            //           customPopup.style.left = e.clientX - startX + "px";
            //           customPopup.style.top = e.clientY - startY + "px";
            //         }
            //       };

            //       const onMouseUp = () => {
            //         isDragging = false;
            //         document.removeEventListener("mousemove", onMouseMove);
            //         document.removeEventListener("mouseup", onMouseUp);
            //       };

            //       document.addEventListener("mousemove", onMouseMove);
            //       document.addEventListener("mouseup", onMouseUp);
            //     });
            //   }

            //   currentLayerTitle = firstLayer.graphic.layer.title;

            //   window.showDetails = async function (layerTitle) {
            //     if (currentLayerTitle !== layerTitle) {
            //       const selectedFeature = uniqueLayers[layerTitle];  // Get the selected feature based on layer title
            //       if (selectedFeature) {
            //         // Find the popup configuration for the selected layer
            //         let selectedLayerConfig = '';
            //         const layerTitles = [
            //           'აფეთქების ნებართვა ძველი',
            //           'I სტადიის ობიექტები ძველი',
            //           'II და III სტადიის ობიექტები ძველი',
            //           'უწყებრივი რეესტრი ძველი',
            //           'ამიაკზე მომუშავე სამაცივრე დანადგარი ძველი',
            //           'ამწე მოწყობილობა ძველი',
            //           'ატრაქციონი ძველი',
            //           'ესკალატორი ძველი',
            //           'კარიერი ძველი',
            //           'ლიფტი ძველი',
            //           'მაგისტრალური ნავთობსადენი ძველი',
            //           'მაღარო ძველი',
            //           'ნავთობბაზა ძველი',
            //           'საბაგირო გზა ძველი',
            //           'საქვაბე დანადგარი ძველი',
            //           'წნევაზე მომუშავე ჭურჭელი ძველი',
            //           'უწყებრივი რეესტრი (ხაზოვანი ობიექტები) ძველი'
            //         ];
            //         if (layerTitle.includes('ძველი')) {
            //           if (layerTitles.includes(layerTitle)) {
            //             selectedLayerConfig = popupConfigsArray.find(config => config.attributes.LayerName === layerTitle);
            //           }
            //         }
            //         else {
            //           selectedLayerConfig = popupConfigsArray.find(config => config.attributes.LayerName === layerTitle);
            //         }
            //         const attributes = selectedFeature.graphic.attributes;
            //         customPopup.innerHTML = `<div id ="PopupLoader"></div>`;

            //         // Perform a query to get the features based on the layer title
            //         const query = selectedFeature.graphic.layer.createQuery();
            //         const queryResponse = await selectedFeature.graphic.layer.queryFeatures(query);

            //         if (!queryResponse.features || queryResponse.features.length === 0) {
            //           customPopup.innerHTML = `<div>No features found for layer ${layerTitle}</div>`;
            //           return;
            //         }
            //         if (!selectedLayerConfig) {
            //           customPopup.innerHTML = `<div> ${layerTitle}</div>`;
            //           return;
            //         }
            //         // Retrieve the first feature from the query response
            //         const feature = queryResponse.features[0];
            //         const featureAttributes = feature.attributes;

            //         // Filter the attributes based on PopupFields
            //         const popupFields = selectedLayerConfig.attributes.PopupFields.split(',').map(field => field.trim());
            //         const filteredAttributes = {};

            //         // Iterate over the fields and filter the attributes
            //         popupFields.forEach(field => {
            //           // Split the field by ' - ' to get the field name and alias
            //           const [fieldName, alias] = field.split(" - ").map(part => part.trim());

            //           // Check if the fieldName exists in the attributes
            //           if (featureAttributes.hasOwnProperty(fieldName)) {
            //             // Store the field value along with the alias
            //             filteredAttributes[alias] = featureAttributes[fieldName];
            //           }
            //         });

            //         // Generate the table based on filtered attributes
            //         customPopup.innerHTML = `
            //         <div>
            //           <h3>${selectedFeature.graphic.layer.title}</h3>
            //           ${generateTable(filteredAttributes)}  <!-- Use the filtered attributes here -->
            //           <hr>
            //           ${popupContent}
            //         </div>
            //       `;

            //         currentLayerTitle = layerTitle;  // Update the current layer to the clicked layer
            //       }
            //     }
            //   };
            // }
            if (firstLayer.graphic.layer.title.includes("ძველი")) {
              if (!firstLayerConfig) {
                customPopup.innerHTML = `<div> ${firstLayer.graphic.layer.title}</div>`;
                return;
              }

              const selectedFeature = firstLayer.graphic;
              const layer = selectedFeature.layer;

              // ფუნქცია, რომელიც პასუხისმგებელია მონაცემების სრულად წამოღებაზე
              const getAttributesSecurely = async (graphic) => {
                // თუ გრაფიკს უკვე აქვს ყველა ატრიბუტი, პირდაპირ დავაბრუნოთ
                if (graphic.attributes && Object.keys(graphic.attributes).length > 5) {
                  return graphic.attributes;
                }

                // თუ არა, გავაკეთოთ სწრაფი ქუერი სერვერზე OBJECTID-ით
                const query = layer.createQuery();
                query.objectIds = [graphic.attributes.OBJECTID || graphic.attributes.oid || graphic.attributes.fid];
                query.outFields = ["*"];
                query.returnGeometry = false; // სისწრაფისთვის გეომეტრია არ გვინდა

                const response = await layer.queryFeatures(query);
                return response.features.length > 0 ? response.features[0].attributes : graphic.attributes;
              };

              const renderPopup = async (graphic, config) => {
                // 1. ვაჩვენებთ ლოუდერს
                customPopup.innerHTML = `<div id="PopupLoader" style="padding:10px;">მონაცემები იტვირთება...</div>`;

                try {
                  // 2. ვიღებთ სრულ ატრიბუტებს
                  const fullAttributes = await getAttributesSecurely(graphic);

                  // 3. ვფილტრავთ კონფიგურაციის მიხედვით
                  const popupFields = config.attributes.PopupFields.split(',').map(field => field.trim());
                  const filteredAttributes = {};

                  popupFields.forEach(field => {
                    const [fieldName, alias] = field.split(" - ").map(part => part.trim());
                    if (fullAttributes.hasOwnProperty(fieldName)) {
                      filteredAttributes[alias] = fullAttributes[fieldName];
                    }
                  });

                  // 4. ვხატავთ ცხრილს
                  customPopup.innerHTML = `
                <div style="min-width: 250px;">
                    <h3 style="margin-top:0;">${graphic.layer.title}</h3>
                    ${generateTable(filteredAttributes)}
                    <hr>
                    ${popupContent || ""}
                </div>
            `;

                  // დრაგის ჩართვა
                  setupPopupDraggable(customPopup);

                } catch (error) {
                  customPopup.innerHTML = `<div>მონაცემების წაკითხვა ვერ მოხერხდა</div>`;
                }
              };

              // გამოძახება პირველი ქლიკისას
              renderPopup(selectedFeature, firstLayerConfig);

              currentLayerTitle = layer.title;

              // showDetails ფუნქციის განახლება
              window.showDetails = async function (layerTitle) {
                if (currentLayerTitle !== layerTitle) {
                  const selected = uniqueLayers[layerTitle];
                  if (selected) {
                    const config = popupConfigsArray.find(c => c.attributes.LayerName === layerTitle);
                    if (config) {
                      await renderPopup(selected.graphic, config);
                      currentLayerTitle = layerTitle;
                    }
                  }
                }
              };
            }


            // else {
            //   if (!firstLayerConfig) {
            //     customPopup.innerHTML = `<div> ${firstLayer.graphic.layer.title}</div>`;
            //     return;
            //   }
            //   const selectedFeature = firstLayer.graphic;
            //   const layer = selectedFeature.layer;

            //   const query = layer.createQuery();
            //   query.where = `OBJECTID = ${selectedFeature.attributes.OBJECTID}`; // Assuming OBJECTID is available
            //   query.outFields = ["*"];  // Request all fields

            //   // Perform the query to get all attributes
            //   const queryResponse = await layer.queryFeatures(query);

            //   // Ensure we have features in the response
            //   if (queryResponse.features.length > 0) {
            //     const attributes = queryResponse.features[0].attributes;

            //     // Filter attributes based on PopupFields from the configuration
            //     const popupFields = firstLayerConfig.attributes.PopupFields.split(',').map(field => field.trim());

            //     // Filter the attributes to only include those listed in PopupFields
            //     const filteredAttributes = {};
            //     popupFields.forEach(field => {
            //       // Split the field by ' - ' to get the field name and alias
            //       const [fieldName, alias] = field.split(" - ").map(part => part.trim());

            //       // Check if the fieldName exists in the attributes
            //       if (attributes.hasOwnProperty(fieldName)) {
            //         // Store the field value along with the alias
            //         filteredAttributes[alias] = attributes[fieldName];
            //       }
            //     });

            //     //   // Generate the table based on filtered attributes
            //     //   customPopup.innerHTML = `
            //     //   <div>
            //     //     <h3>${firstLayer.graphic.layer.title}</h3>
            //     //     ${generateTable(filteredAttributes)}  <!-- Pass the filtered attributes here -->
            //     //     <hr>
            //     //     ${popupContent}
            //     //   </div>
            //     // `;
            //     customPopup.innerHTML = `
            //     <div>
            //       <h3>${firstLayer.graphic.layer.title}</h3>
            //       ${generateTable(filteredAttributes)}
            //       <hr>
            //       ${popupContent}
            //     </div>
            //   `;
            //     // Optional: Add drag functionality
            //     let isDragging = false;

            //     customPopup.addEventListener("mousedown", (e) => {
            //       isDragging = true;
            //       let startX = e.clientX - customPopup.offsetLeft;
            //       let startY = e.clientY - customPopup.offsetTop;

            //       const onMouseMove = (e) => {
            //         if (isDragging) {
            //           customPopup.style.left = e.clientX - startX + "px";
            //           customPopup.style.top = e.clientY - startY + "px";
            //         }
            //       };

            //       const onMouseUp = () => {
            //         isDragging = false;
            //         document.removeEventListener("mousemove", onMouseMove);
            //         document.removeEventListener("mouseup", onMouseUp);
            //       };

            //       document.addEventListener("mousemove", onMouseMove);
            //       document.addEventListener("mouseup", onMouseUp);
            //     });
            //   }
            //   // // Ensure we have features in the response
            //   // if (queryResponse.features.length > 0) {
            //   //   const attributes = queryResponse.features[0].attributes;

            //   //   // Filter attributes based on PopupFields from the configuration
            //   //   var popupFields = attributes;

            //   //   // Filter the attributes to only include those listed in PopupFields
            //   //   const filteredAttributes = {};
            //   //   filteredAttributes['განაცხადის №'] = attributes['Registraciis_N'];
            //   //   filteredAttributes['აიტვირთა'] = attributes['Registraciis_Tarigi'];
            //   //   filteredAttributes['სრულდება'] = '';
            //   //   filteredAttributes['ობიექტი'] = attributes['Obieqtis_Dasaxeleba'];
            //   //   filteredAttributes['მოთხოვნა'] = attributes['Obieqtis_Mflobeli'];
            //   //   filteredAttributes['სტატუსი'] = '';
            //   //   filteredAttributes['დეტალური'] = 'https://tcsa.tacsa.gov.ge/dashboard/createexpercase?id=' + attributes.OBJECTID;
            //   //   customPopup.innerHTML = `
            //   //   <div>
            //   //     <h3>${firstLayer.graphic.layer.title}</h3>
            //   //     ${generateTable(filteredAttributes)}
            //   //     <hr>
            //   //     ${popupContent}
            //   //   </div>
            //   // `;
            //   //   // Optional: Add drag functionality
            //   //   let isDragging = false;

            //   //   customPopup.addEventListener("mousedown", (e) => {
            //   //     isDragging = true;
            //   //     let startX = e.clientX - customPopup.offsetLeft;
            //   //     let startY = e.clientY - customPopup.offsetTop;

            //   //     const onMouseMove = (e) => {
            //   //       if (isDragging) {
            //   //         customPopup.style.left = e.clientX - startX + "px";
            //   //         customPopup.style.top = e.clientY - startY + "px";
            //   //       }
            //   //     };

            //   //     const onMouseUp = () => {
            //   //       isDragging = false;
            //   //       document.removeEventListener("mousemove", onMouseMove);
            //   //       document.removeEventListener("mouseup", onMouseUp);
            //   //     };

            //   //     document.addEventListener("mousemove", onMouseMove);
            //   //     document.addEventListener("mouseup", onMouseUp);
            //   //   });
            //   // }

            //   currentLayerTitle = firstLayer.graphic.layer.title;

            //   window.showDetails = async function (layerTitle) {
            //     if (currentLayerTitle !== layerTitle) {
            //       const selectedFeature = uniqueLayers[layerTitle];  // Get the selected feature based on layer title
            //       if (selectedFeature) {
            //         // Find the popup configuration for the selected layer
            //         const selectedLayerConfig = popupConfigsArray.find(config => config.attributes.LayerName === layerTitle);
            //         const attributes = selectedFeature.graphic.attributes;
            //         customPopup.innerHTML = `<div id ="PopupLoader"></div>`;

            //         // Perform a query to get the features based on the layer title
            //         const query = selectedFeature.graphic.layer.createQuery();
            //         const queryResponse = await selectedFeature.graphic.layer.queryFeatures(query);

            //         if (!queryResponse.features || queryResponse.features.length === 0) {
            //           customPopup.innerHTML = `<div>No features found for layer ${layerTitle}</div>`;
            //           return;
            //         }
            //         if (!selectedLayerConfig) {
            //           customPopup.innerHTML = `<div> ${layerTitle}</div>`;
            //           return;
            //         }

            //         // Retrieve the first feature from the query response
            //         const feature = queryResponse.features[0];
            //         const featureAttributes = feature.attributes;

            //         // Filter the attributes based on PopupFields
            //         const popupFields = selectedLayerConfig.attributes.PopupFields.split(',').map(field => field.trim());
            //         const filteredAttributes = {};

            //         // Iterate over the fields and filter the attributes
            //         popupFields.forEach(field => {
            //           // Split the field by ' - ' to get the field name and alias
            //           const [fieldName, alias] = field.split(" - ").map(part => part.trim());

            //           // Check if the fieldName exists in the attributes
            //           if (featureAttributes.hasOwnProperty(fieldName)) {
            //             // Store the field value along with the alias
            //             filteredAttributes[alias] = featureAttributes[fieldName];
            //           }
            //         });

            //         // Generate the table based on filtered attributes
            //         customPopup.innerHTML = `
            //         <div>
            //           <h3>${selectedFeature.graphic.layer.title}</h3>
            //           ${generateTable(filteredAttributes)}  <!-- Use the filtered attributes here -->
            //           <hr>
            //           ${popupContent}
            //         </div>
            //       `;

            //         currentLayerTitle = layerTitle;  // Update the current layer to the clicked layer
            //       }
            //     }
            //   };
            // }
            else {
              if (!firstLayerConfig) {
                customPopup.innerHTML = `<div> ${firstLayer.graphic.layer.title}</div>`;
                return;
              }

              // დამხმარე ფუნქცია ატრიბუტების წამოსაღებად და დასაფილტრად
              const getLayerAttributes = async (graphic, config) => {
                let attrs = graphic.attributes;

                // თუ ატრიბუტები აკლია, ვაკეთებთ სწრაფ ქუერის OBJECTID-ით
                if (!attrs || Object.keys(attrs).length <= 2) {
                  const query = graphic.layer.createQuery();
                  // ვამოწმებთ სხვადასხვა შესაძლო ID ველს
                  const oid = attrs.OBJECTID || attrs.oid || attrs.fid || attrs.objectid;
                  query.objectIds = [oid];
                  query.outFields = ["*"];
                  query.returnGeometry = false;

                  const response = await graphic.layer.queryFeatures(query);
                  if (response.features.length > 0) {
                    attrs = response.features[0].attributes;
                  }
                }

                const popupFields = config.attributes.PopupFields.split(',').map(field => field.trim());
                const filtered = {};
                popupFields.forEach(field => {
                  const [fieldName, alias] = field.split(" - ").map(part => part.trim());
                  if (attrs.hasOwnProperty(fieldName)) {
                    filtered[alias] = attrs[fieldName];
                  }
                });
                return filtered;
              };

              // პოპაპის დახატვის მთავარი ფუნქცია
              const updatePopupContent = async (graphic, config) => {
                customPopup.innerHTML = `<div style="padding:10px;">იტვირთება...</div>`;
                const filteredAttributes = await getLayerAttributes(graphic, config);

                customPopup.innerHTML = `
            <div>
                <h3>${graphic.layer.title}</h3>
                ${generateTable(filteredAttributes)}
                <hr>
                ${popupContent}
            </div>
        `;
                setupPopupDraggable(customPopup); // ჩავრთოთ გადაადგილება
              };

              // პირველადი გამოძახება
              updatePopupContent(firstLayer.graphic, firstLayerConfig);
              currentLayerTitle = firstLayer.graphic.layer.title;

              // window.showDetails-ის განახლება
              window.showDetails = async function (layerTitle) {
                if (currentLayerTitle !== layerTitle) {
                  const selectedFeature = uniqueLayers[layerTitle];
                  if (selectedFeature) {
                    const selectedLayerConfig = popupConfigsArray.find(config => config.attributes.LayerName === layerTitle);

                    if (!selectedLayerConfig) {
                      customPopup.innerHTML = `<div> ${layerTitle}</div>`;
                      return;
                    }

                    await updatePopupContent(selectedFeature.graphic, selectedLayerConfig);
                    currentLayerTitle = layerTitle;
                  }
                }
              };
            }


          }
        });
        // Function to check if the layer is a basemap layer
        function isBasemapLayer(layer) {
          return layer.isBasemap ||
            layer.type === "tile" ||
            layer.type === "imagery" ||
            layer.type === "webTile" ||
            layer.type === "vectorTile" ||
            layer.type === "dynamic" ||
            layer.type === "vector-tile"
            ;
        }
        // Close popup when clicking outside
        view.on("pointer-down", (event) => {
          const target = event.native.target;
          if (!customPopup.contains(target)) {
            customPopup.style.display = "none";
            currentLayerTitle = ""; // Reset the current layer title when popup is closed
          }
        });

        // Function to generate a modern table for feature attributes
        function generateTable(attributes) {
          let tableHTML = "<table><tbody>";

          for (const [key, value] of Object.entries(attributes)) {
            // Check if the value is a URL
            const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i; // Regex to validate URL
            if (typeof value === "string" && urlPattern.test(value)) {
              // Render as hyperlink
              tableHTML += `<tr><td>${key}</td><td><a href="${value}" target="_blank">${value}</a></td></tr>`;
            } else {
              // Render normally
              const displayValue = value === null ? "" : value;
              tableHTML += `<tr><td>${key}</td><td>${displayValue}</td></tr>`;
            }
          }

          tableHTML += "</tbody></table>";
          return tableHTML;
        }

        // Function to parse the PopupFields string into key-value pairs
        function parsePopupFields(popupFieldsString) {
          const fieldsArray = popupFieldsString.split(","); // Split by comma
          const fieldsObject = {};

          fieldsArray.forEach(field => {
            const [key, value] = field.split(" - ").map(item => item.trim()); // Split by ' - ' and trim spaces
            if (key && value) {
              fieldsObject[key] = value; // Add key-value pair to the object
            }
          });

          return fieldsObject;
        }


      }
    );
  }
  // <button onClick={handleBackClick}>უკან</button>
  // მარტივი და მუშა Drag ფუნქცია
  function setupPopupDraggable(el) {
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    const header = el.querySelector('h3');

    if (header) {
      header.style.cursor = 'move';
      header.onmousedown = dragMouseDown;
    } else {
      el.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      el.style.top = (el.offsetTop - pos2) + "px";
      el.style.left = (el.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }
  return (
    <div
    // style={{
    //   cursor: popupsEnabled ? "help" : "default", // Change cursor based on state
    // }}
    >
      {loading && (
        <div className="loading-container-for-map">
          <div className="loader-for-map"></div>
        </div>
      )}

      <div
        className="flex-container"
        style={{
          height:
            location.pathname.includes("interactivemap") ||
              location.pathname.includes("map")
              ? "100vh"
              : "100%",
        }}
      >
        <div id="layerListPanel"></div>
        <button title={t("გამოშლა")} id="toggleSidebarBtn">
          &lt;
        </button>
        <div id="InteractiveMap" className="InteractiveMap webmap" ref={mapRef}>
          <div id="loader"></div>
          <div id="customPopup"></div>
          <button id="toolsToggleBtn" onClick={handleToggle}>
            {hamToggle ? <RxCross1 /> : <RxHamburgerMenu />}
          </button>
          <div id="toolsPanel" className="show">
            <div
              className="button-container-of-toolspanel"
              style={{ marginTop: "0px" }}
            >
              <li className="toolsPanelli">
                <button
                  id="infoButton"
                  className="esri-widget--button esri-interactive esri-icon-description"
                  title={t("გამოაჩინე ფენის პოპაპები")}
                ></button>
              </li>
              <li className="toolsPanelli" title={t("ლეგენდა")}>
                <div id="legendExpandDiv"></div>
              </li>
              <li className="toolsPanelli">
                <button
                  id="distance"
                  className="esri-widget--button esri-interactive esri-icon-measure-line"
                  title={t("მანძილის მზომი")}
                ></button>
              </li>
              <li className="toolsPanelli">
                <button
                  id="area"
                  className="esri-widget--button esri-interactive esri-icon-measure-area"
                  title={t("ფართობის მზომი")}
                ></button>
              </li>
              <li className="toolsPanelli">
                <button
                  id="clear"
                  className="esri-widget--button esri-interactive esri-icon-trash"
                  title={t("გასუფთავება")}
                ></button>
              </li>
              <li className="toolsPanelli" title={t("ამოპრინტვა")}>
                <div id="printExpandDiv"></div>
              </li>

            </div>
          </div>

          {showMapPopup && (
            <div ref={popupRef} className="popupMapHasNoGraphic">
              <h2>{t("ობიექტს არ აქვს მიბმული გრაფიკა!")}</h2>
              <button
                //  className="popupWithoutGraphicBtn"
                onClick={togglePopup}
              >
                {t("დახურვა")}
              </button>
            </div>
          )}
        </div>
        {/* <div id="basemapToggleBtn">
          <img id="thumbnailPreview" src="" alt="Basemap Thumbnail" />
        </div> */}


        <div id="basemapGalleryDiv"></div>
        <div id="search-container">
          <div id="searchDiv">
            <div className="relativeContainer">
              <input
                id="searchText"
                className="searchText"
                placeholder={t("ძებნა...")}
              >
              </input>

              {showSearchSettingsPopup ? (
                <button
                  id="closesearchsearchSettingsPopup"
                  className="closeSearchSettingsbutton"
                  onClick={closeSearchSettingsPopup}
                >
                  <RxCross1 />
                </button>
              ) : (
                <button
                  type="button"
                  className="searchText"
                  id="searchSettingsButton"
                  onClick={toggleSearchSettingsPopup}
                >
                  <FontAwesomeIcon className="search-icon" icon={faCog} />
                </button>
              )}

              <button type="button" className="searchText" id="searchButton">
                <FontAwesomeIcon className="search-icon" icon={faSearch} />
              </button>
              {/* Clear Search Button */}
              <button type="button" className="searchText" id="clearSearchButton">
                <FontAwesomeIcon className="search-icon" icon={faTimes} />
              </button>
            </div>

            <div id="suggestions"></div>
            {showSearchSettingsPopup && (
              <div id="searchSettingsPopup" className="searchSettingsPopup">
                <div>
                  <input
                    type="checkbox"
                    id="tcsaLayerChecked"
                    checked={tcsaLayerChecked}
                    onChange={(e) => setTCSALayerChecked(e.target.checked)}
                  />
                  <label for="tcsaLayerChecked">{t("TCSA ბაზა")}</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    id="sakadastroLayerChecked"
                    checked={sakadastroLayerChecked}
                    onChange={(e) =>
                      setsakadastroLayerChecked(e.target.checked)
                    }
                  />
                  <label for="sakadastroLayerChecked">
                    {t("საჯარო რეესტრის ბაზა")}{" "}
                  </label>
                </div>

                {tcsaLayerChecked && sakadastroLayerChecked && (
                  <>
                    <p
                      style={{
                        fontStyle: "italic",
                        fontSize: "11px",
                        marginLeft: "8px",
                      }}
                    >
                      {t("მონაცემების მოძებნა ორივე ბაზიდან მოითხოვს შედარებით დიდ დროს")}
                      <FaExclamation style={{ color: "red" }} />
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        <button className="back_button" onClick={handleBackClick}>
          <RiArrowGoBackFill />
        </button>
      </div>

    </div>
  );
};
export default InteractiveMap;
